import { Button, ButtonProps } from "../core/components/button";
import { DropDownList } from "../core/components/dropDownList";
import { FAIcon } from "../core/components/faIcon";
import { BreakPoint, GridLayoutItem, SimpleGridLayout } from "../core/components/gridLayout";
import { MultiSelect } from "../core/components/multiSelect";
import { Region } from "../core/components/region";
import { Dialog, DialogProps } from "../core/components/dialog";
import { TextBox, TextBoxProps } from "../core/components/textBox";
import { HTTPService } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { locale } from "../../typeinfo/moment";
import { Config } from "../core/config/config";
import React from "react";
import ReactDOM from "react-dom";

export default class TranslationEditorView extends React.Component<any, TranslationEditorViewState> {

    constructor(props) {
        super(props);

        this.state = {
            translations: { translations: null },
            customResourcesAvailable: true,
            globalLanguages: null,
            globalModules: null,
            filterLabels: null,
            translationFilter: {
                selectedModules: [],
                selectedLabel: {
                    labelId: "-1",
                    name: 'all',
                    iconName: null
                },
                selectedLanguages: localStorage.getItem('selectedLanguages') ? JSON.parse(localStorage.getItem('selectedLanguages')) : ['en'],
                searchValue: null
            },
            translationSettings: {
                setReviewed: localStorage.getItem('setReviewed') ? JSON.parse(localStorage.getItem('setReviewed')) : true,
                autoRemove: localStorage.getItem('autoRemove') ? JSON.parse(localStorage.getItem('autoRemove')) : true
            },
            multiSelect: {
                enabled: false,
                selectedIds: []
            },
            selectedRow: 0,
            selectedId: null,
            pageNumber: 1,
            itemsPerPage: localStorage.getItem('itemsPerPage') ? JSON.parse(localStorage.getItem('itemsPerPage')) : 50,
            saveDialogOpen: false,
            saveDialogInit: false,
            currentRevisions: null,
            propertyKeysExtendedIds: [],
            buttonHoverEnabled: false,
            propertyKeyDialogOpen: false,
            propertyKeyDialogInit: false,
            importResourceDialogOpen: false
        };
    }

    filteredIds: string[] = [];
    pageIds: string[] = [];
    init: boolean = true;

    componentDidUpdate() {
        if (!this.state.translations.translations || this.init) {

            this.init = false;

            this.setState((state, props) => {
                let data = props.context.hasOwnProperty('translationData') ? props.context.translationData : null;
                let labels = data ? data.labels as Label[] : null;
                labels = [
                    {
                        labelId: "-1",
                        name: 'all',
                        iconName: null
                    },
                    {
                        labelId: "-2",
                        name: 'none',
                        iconName: null
                    },
                    {
                        labelId: "-3",
                        name: 'untranslated',
                        iconName: null
                    },
                    {
                        labelId: "-4",
                        name: 'custom',
                        iconName: null
                    }
                ].concat(labels);
                return {
                    translations: { translations: data ? data.translations as Translation[] : null },
                    globalLanguages: data ? data.languages as Language[] : null,
                    globalModules: data ? data.modules as Module[] : null,
                    filterLabels: labels,
                    selectedId: data ? data.translations[0]?.tId : null,
                    selectedRow: 0,
                    pageNumber: 1,
                    customResourcesAvailable: props.context.hasOwnProperty('customResourcesAvailable') ? props.context.customResourcesAvailable : false
                };
            });
        }

        if ((this.props.context.updatedValues && this.props.context.updatedValues.length > 0) || (this.props.context.updatedTranslations && this.props.context.updatedTranslations.length > 0)) {
            this.setState(currentState => {
                let state = currentState as TranslationEditorViewState;
                let { translations } = state.translations;

                for (let translation of this.props.context.updatedValues) {
                    let transValue = translations.find(t => t.tId === translation.tId).translationsPerLanguage[state.globalLanguages.find(l => l.langId === translation.langId).langCode];
                    if (!transValue.value.customId || transValue.value.customId !== translation.id) {
                        transValue.value.customId = translation.id;
                    }
                }

                if (this.props.context.updatedTranslations && this.props.context.updatedTranslations.length > 0) {
                    for (let translation of this.props.context.updatedTranslations) {
                        let trans = translations.find(t => t.keys[0].key === translation.keys[0].key);
                        if (!trans.tId || trans.tId !== translation.tId) {
                            trans.tId = translation.tId;
                        }
                    }
                }

                this.props.context.clearUpdateList();
                return state;
            });
        }
    }

    onSaveDialogInitialized = () => {
        this.setState({ saveDialogInit: false });
    }

    onExtend = (id) => {
        if (!id) {
            this.setState({ propertyKeysExtendedIds: [] });
        }
        else {
            this.setState(currentState => {
                let state = currentState as TranslationEditorViewState;

                if (state.propertyKeysExtendedIds.includes(id)) {
                    let index = state.propertyKeysExtendedIds.indexOf(id);
                    state.propertyKeysExtendedIds.splice(index, 1);
                }
                else {
                    state.propertyKeysExtendedIds.push(id);
                }

                return state;
            });
        }
    }

    onSort = (sort: Sort) => {
        const { column, direction } = sort;

        this.setState(currentState => {
            let state = currentState as TranslationEditorViewState;

            let { translations } = state.translations;
            switch (sort.column) {
                case 'keys':
                    state.translations.translations = translations.sort((a, b) => {
                        return direction === 'asc' ? a.keys[0].key.localeCompare(b.keys[0].key) : b.keys[0].key.localeCompare(a.keys[0].key);
                    });
                    break;
                case null:
                    state.translations.translations = translations.sort((a, b) => a.tId < b.tId ? -1 : 1);
                    break;
                default:
                    state.translations.translations = translations.sort((a, b) => {
                        if (!a.translationsPerLanguage.hasOwnProperty(column))
                            return direction === 'asc' ? -1 : 1;
                        if (!b.translationsPerLanguage.hasOwnProperty(column))
                            return direction === 'asc' ? 1 : -1;

                        const aVal = a.translationsPerLanguage[column].value;
                        const bVal = b.translationsPerLanguage[column].value;
                        const aComp = aVal.custom && aVal.custom !== '' ? aVal.custom : aVal.default;
                        const bComp = bVal.custom && bVal.custom !== '' ? bVal.custom : bVal.default;
                        if (!aComp || aComp === '')
                            return direction === 'asc' ? -1 : 1;
                        if (!bComp || bComp === '')
                            return direction === 'asc' ? 1 : -1;

                        return direction === 'asc' ? (aComp.toLowerCase() < bComp.toLowerCase() ? -1 : 1) : (aComp.toLowerCase() < bComp.toLowerCase() ? 1 : -1);
                    });
                    break;
            }
            state.selectedRow = null;

            if (state.translations.translations[0].tId === state.selectedId) {
                document.getElementById("data-table-wrapper").scrollTop = 0;
            }
            return state;
        });
    }

    onPropertyKeyDialogOpen = () => {
        this.setState({ propertyKeyDialogOpen: true, propertyKeyDialogInit: true });
    }

    onPropertyKeyDialogInitialized = () => {
        this.setState({ propertyKeyDialogInit: false });
    }

    saveNewPropertyKey = (save: boolean, propertyKey?: string, moduleId?: string) => {
        if (save) {
            this.setState(currentState => {
                let state = currentState as TranslationEditorViewState;

                let maxId = Math.max(...state.translations.translations.map(t => Number(t.tId)));
                state.translations.translations = [{
                    tId: maxId >= 10000 ? (maxId + 1).toString() : '10000',
                    translationKey: null,
                    keys: [{ key: propertyKey, moduleId: moduleId }],
                    moduleIds: [moduleId],
                    translationsPerLanguage: {}
                } as Translation].concat(state.translations.translations);

                state.selectedRow = null;
                state.pageNumber = 1;

                state.propertyKeyDialogOpen = false;
                return state;
            });
        }
        else
            this.setState({ propertyKeyDialogOpen: false });
    }

    toggleHoverAnimation = (enable: boolean) => {
        this.setState({ buttonHoverEnabled: enable });
    }

    renderContent() {
        if (this.props.context.hasOwnProperty('translationData') && this.props.context.translationData && this.state.translations.translations) {
            const editorTranslations = this.props.translations;
            const { translations, globalModules, currentRevisions, globalLanguages, translationFilter, filterLabels, multiSelect, selectedId, selectedRow, pageNumber, itemsPerPage, propertyKeysExtendedIds, saveDialogOpen, saveDialogInit, buttonHoverEnabled, propertyKeyDialogOpen, propertyKeyDialogInit } = this.state;
            const selectedTranslation = find(translations.translations, 'tId', selectedId);

            const newTranslationButtonPosition = 275 + (multiSelect.enabled ? 54 : 0) + (this.state.translationFilter.selectedLanguages.length > 2 ? 103 : (this.state.translationFilter.selectedLanguages.length === 2 ? 49 : 0));

            return (
                <>
                    <div style={{ flex: '0 0 auto' }} id="filter">
                        <SimpleGridLayout>
                            <GridLayoutItem layoutConfig={[{ size: '12/12', breakPoint: BreakPoint.Small }]}>
                                <Region title="Search filter">
                                    <TranslationSearchFilter globalModules={globalModules} labels={filterLabels} globalLanguages={globalLanguages} currentFilter={translationFilter} onChange={this.updateFilter} editorTranslations={editorTranslations} />
                                </Region>
                            </GridLayoutItem>
                        </SimpleGridLayout>
                    </div>
                    <TranslationTable tableWidth={document.getElementById("data-table-wrapper") ? document.getElementById("data-table-wrapper").offsetWidth : null} translations={translations} translationFilter={translationFilter} globalLanguages={globalLanguages} selectedRow={selectedRow} selectedId={selectedId} multiSelect={multiSelect} pageNumber={pageNumber} itemsPerPage={itemsPerPage} propertyKeysExtendedIds={propertyKeysExtendedIds} changeTranslation={this.changeTranslation} selectPage={this.selectPage} selectRow={this.selectRow} setIds={this.setIds} onSelect={this.selectTranslation} onExtend={this.onExtend} onSort={this.onSort} editorTranslations={editorTranslations} />
                    <TranslationMultiSelect translations={translations.translations} multiSelect={multiSelect} selectedId={selectedId} filteredIds={this.filteredIds} onChange={this.updateMultiSelect} setLabels={this.multiSelectSetLabels} editorTranslations={editorTranslations} />
                    <div style={{ flex: '0 0 ' + (this.state.translationFilter.selectedLanguages.length > 2 ? 236 : (this.state.translationFilter.selectedLanguages.length === 2 ? 180 : 131)) + 'px', position: 'relative' }}>
                        <TranslationDetails translation={selectedTranslation} languages={translationFilter.selectedLanguages} globalLanguages={globalLanguages} globalModules={globalModules} labels={filterLabels.filter(label => Number(label.labelId) >= 0 || label.name === 'none')} onChange={this.updateTranslations} editorTranslations={editorTranslations} />
                        {/*<div style={{ position: 'absolute', bottom: '15px', right: '20px', gap: '10px', display: 'flex', flexDirection: 'row' }}>
                            <button id="prev" className="k-button k-grid" type="button" disabled={(Number(selectedRow) === 0 && Number(pageNumber) === 1) || selectedRow === null} style={{ minWidth: '85px', height: '36px', padding: '0 12px', borderRadius: '0.375rem' }} onClick={this.changeTranslation}>
                                <div id="prev" style={{ minWidth: '64px' }}>
                                    editorTranslations['WebSMS.TransEditor.ActionPrevious']
                                </div>
                            </button>
                            <button id="next" className="k-button k-grid" type="button" disabled={!this.pageIds || this.pageIds.length === 0 || (selectedRow !== null && selectedRow === this.pageIds.length - 1 && Math.ceil(this.filteredIds.length / itemsPerPage) === pageNumber)} style={{ minWidth: '85px', height: '36px', padding: '0 12px', borderRadius: '0.375rem' }} onClick={this.changeTranslation}>
                                <div id="next" style={{ minWidth: '64px' }}>
                                    editorTranslations['WebSMS.TransEditor.ActionNext']
                                </div>
                            </button>
                        </div>*/}
                        <div key="new-translations" title={editorTranslations['WebSMS.TransEditor.NewTranslation.Title']} style={{ backgroundColor: "#CC3467", color: "white", position: "absolute", bottom: `${newTranslationButtonPosition}px`, right: "50px", width: "60px", height: "60px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "30px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)", cursor: "pointer", transform: `scale(${buttonHoverEnabled ? '1.05' : '1.0'})` }} onClick={this.onPropertyKeyDialogOpen} onMouseEnter={_ => this.toggleHoverAnimation(true)} onMouseLeave={_ => this.toggleHoverAnimation(false)}>
                            <FAIcon name="plus" attributes={["2x"]} />
                        </div>
                    </div>
                    <TranslationRevisionDialog saveDialogOpen={saveDialogOpen} doInit={saveDialogInit} onInit={this.onSaveDialogInitialized} globalModules={globalModules} globalLanguages={globalLanguages} closeDialog={this.closeDialog} currentRevisions={currentRevisions} translations={translations.translations} translationFilter={translationFilter} editorTranslations={editorTranslations} />
                    <NewPropertyKeyDialog modules={globalModules} existingKeys={[].concat(...translations.translations.map(t => t.keys.map(k => k.key)))} init={propertyKeyDialogInit} open={propertyKeyDialogOpen} onInit={this.onPropertyKeyDialogInitialized} closeDialog={this.saveNewPropertyKey} editorTranslations={editorTranslations} />
                </>
            );
        }
        return null;
    }

    importCustomTranslationsFromResources = () => {
        HTTPService.post("TranslationsView/ImportCustomTranslations/")
            .then(message => {

                if (message.Success) {
                    this.init = true;

                    this.props.context.initTranslationData();
                    NotificationHelper.showSuccessMessage(message.Message);
                }
                else {
                    NotificationHelper.showErrorMessage(message.Message);
                }
            });

        this.setState({ importResourceDialogOpen: false });
    }

    renderSettings() {
        if (this.props.context.hasOwnProperty('translationData') && this.props.context.translationData && this.state.translations.translations) {
            const editorTranslations = this.props.translations;
            const { translations, translationFilter, translationSettings, multiSelect, globalLanguages, importResourceDialogOpen, customResourcesAvailable } = this.state;

            let importResourcesButtonStyle: React.CSSProperties = {
                minWidth: '95px',
                height: '36px',
                margin: '15px 20px 0',
                padding: '0 11px',
                display: 'flex',
                flexDirection: 'row',
                borderRadius: '0.375rem',
                gap: '7px'
            };

            if (!customResourcesAvailable) {
                importResourcesButtonStyle.borderColor = '#bdbdbd';
                importResourcesButtonStyle.opacity = '0.65';
            }

            let importResourcesDialogProps: DialogProps = {
                title: editorTranslations['WebSMS.TransEditor.Attention.Header'],
                actions: [
                    {
                        label: editorTranslations['WebSMS.TransEditor.ActionCancel'],
                        action: () => this.setState({ importResourceDialogOpen: false })
                    },
                    {
                        label: editorTranslations['WebSMS.TransEditor.ActionContinue'],
                        action: () => this.importCustomTranslationsFromResources(),
                        primary: true
                    }],
                afterClose: () => { if (importResourceDialogOpen) this.setState({ importResourceDialogOpen: false }) },
                maxHeight: '250px'
            };

            return (
                <div style={{ overflowY: 'visible' }}>
                    <TranslationSettings settings={translationSettings} onChange={this.applySettings} editorTranslations={editorTranslations} />
                    <TranslationImportExport translations={translations.translations} selectedLanguages={translationFilter.selectedLanguages} globalLanguages={globalLanguages} selectedIds={multiSelect.selectedIds} multiSelect={multiSelect.enabled} replaceTranslations={this.updateTranslations} editorTranslations={editorTranslations} />
                    <div style={{ paddingBottom: '20px' }}>
                        <div style={{ fontWeight: 550, margin: '24px 0 5px 15px', paddingRight: '5px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                            {editorTranslations['WebSMS.TransEditor.ImportResources.Header']}
                        </div>
                        <button id="import" className="k-button k-grid" type="button" title={editorTranslations['WebSMS.TransEditor.ImportResources.Title']} disabled={false} style={importResourcesButtonStyle} onClick={_ => customResourcesAvailable ? this.setState({ importResourceDialogOpen: true }) : this.importCustomTranslationsFromResources()}>
                            <FAIcon name={'file-lines'} prefix={"fal"} />
                            <div>
                                {editorTranslations['WebSMS.TransEditor.ActionImport']}
                            </div>
                        </button>
                    </div>
                    {
                        Config.user.isSysAdmin ?
                            <TranslationDevImportExport translations={translations.translations} globalLanguages={globalLanguages} selectedIds={multiSelect.selectedIds} multiSelect={multiSelect.enabled} replaceTranslations={this.updateTranslations} editorTranslations={editorTranslations} />
                            : null
                    }
                    <Dialog {...importResourcesDialogProps} open={importResourceDialogOpen}>
                        <div style={{ width: '470px', height: '85px', padding: '0 5px', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ marginBottom: '5px', paddingLeft: '8px' }}>
                                {editorTranslations['WebSMS.TransEditor.DialogImportWarning1']}
                            </div>
                            <div style={{ paddingLeft: '8px' }}>
                                {editorTranslations['WebSMS.TransEditor.DialogImportWarning2']}
                            </div>
                        </div>
                    </Dialog>
                </div>
            );
        }
        return null;
    }

    selectTranslation = (translation: Translation, row: number, preserveId?: boolean, clearExtensions?: boolean) => {
        this.setState(currentState => {
            let state = currentState as TranslationEditorViewState;
            let { multiSelect } = state;

            if (!multiSelect.enabled) {
                state.selectedRow = row;
                state.selectedId = translation ? translation.tId : null;
            }
            else {
                if (!includes(multiSelect.selectedIds, translation.tId) || preserveId) {
                    if (!includes(multiSelect.selectedIds, translation.tId)) {
                        state.multiSelect.selectedIds.push(translation.tId);
                    }
                    state.selectedRow = row;
                    state.selectedId = translation.tId;
                }
                else {
                    let ids = [] as string[];
                    for (let id of multiSelect.selectedIds) {
                        if (id !== translation.tId || multiSelect.selectedIds.length === 1) {
                            ids.push(id);
                        }
                    }

                    state.multiSelect.selectedIds = ids;
                    state.selectedId = state.selectedRow == row ? ids[ids.length - 1] : state.selectedId;
                    state.selectedRow = state.selectedRow == row ? null : state.selectedRow;
                }
            }

            if (clearExtensions) {
                state.propertyKeysExtendedIds = [];
            }

            return state;
        });
    }

    updateFilter = (name: string, value: any) => {
        this.setState(currentState => {
            let state = currentState as TranslationEditorViewState;
            state.translationFilter[name] = value;
            state.selectedRow = name !== 'selectedLanguages' ? null : state.selectedRow;
            state.pageNumber = 1;
            /*
            const search = state.translationFilter.searchValue ?? '';
            if (search !== '') {
                state.translations.translations = state.translations.translations.sort((a, b) => (!a.key.includes(search) ? -1 : (!b.key.includes(search) ? 1 : ((a.key.indexOf(search) < b.key.indexOf(search)) ? 1 : -1))));
            }
            else if */
            return state;
        });
        document.getElementById("data-table-wrapper").scrollTop = 0;

        if (name === 'selectedLanguages') {
            localStorage.setItem(name, JSON.stringify(value));
        }
    }

    selectPage = (pageProp: 'itemsPerPage' | 'pageNumber', value: number) => {
        switch (pageProp) {
            case 'itemsPerPage':
                this.setState({
                    itemsPerPage: value
                });
                localStorage.setItem('itemsPerPage', JSON.stringify(value));
                break;
            case 'pageNumber':
                this.setState(currentState => {
                    let state = currentState as TranslationEditorViewState;

                    state.selectedRow = null;
                    state.pageNumber = value;

                    return state;
                });
                document.getElementById("data-table-wrapper").scrollTop = 0;
        }
    }

    selectRow = (rowNumber: number, clearExtensions?: boolean) => {
        this.setState(currentState => {
            let state = currentState as TranslationEditorViewState;

            state.selectedRow = rowNumber;
            if (clearExtensions) {
                state.propertyKeysExtendedIds = [];
            }

            return state;
        });
    }

    changeTranslation = (event) => {
        const direction = event.target.id;
        const { selectedRow, itemsPerPage, pageNumber } = this.state;
        let row;
        let page;

        if (selectedRow !== null && Number(selectedRow) === 0 && direction === 'prev') {
            row = Number(itemsPerPage) - 1;
            page = Number(pageNumber) - 1;
        }
        else if (selectedRow !== null && Number(selectedRow) === (Number(this.pageIds.length) - 1) && direction === 'next') {
            row = 0;
            page = Number(pageNumber) + 1;
        }
        else {
            row = selectedRow !== null ? (direction === 'prev' ? Number(selectedRow) - 1 : Number(selectedRow) + 1) : 0;
            page = pageNumber;
        }

        let table = document.getElementById("data-table-wrapper");
        const pageChanged = pageNumber !== page;

        if (pageNumber < page) {
            table.scrollTop = 0;
        }
        else if (pageNumber > page) {
            table.scrollTop = table.scrollHeight;
        }

        this.setState(currentState => {
            let state = currentState as TranslationEditorViewState;

            state.selectedRow = row;
            state.selectedId = null;
            state.pageNumber = page;

            return state;
        });

        if (!pageChanged) {
            const { selectedRow } = this.state;
            const scroll = table.scrollTop;
            const offTop = direction === 'prev' ? ((selectedRow - 1) * 28 < scroll) : (selectedRow * 28 < scroll);
            const offBottom = direction === 'prev' ? (Number(selectedRow) * 28 > scroll + table.offsetHeight) : ((Number(selectedRow) + 3) * 28 > scroll + table.offsetHeight);

            if (offTop) {
                table.scrollTop = direction === 'prev' ? ((Number(selectedRow) - 1) * 28) : (selectedRow * 28) + 28;
            }
            else if (offBottom) {
                table.scrollTop = direction === 'prev' ? (((Number(selectedRow) + 1) * 28) - table.offsetHeight + 1) : (((Number(selectedRow) + 3) * 28) - table.offsetHeight + 1);
            }
        }
    }

    updateTranslations = (translations: Translation[], updatedLanguages?: string[]) => {
        if (translations && translations.length > 0) {
            this.setState(currentState => {
                let state = currentState as TranslationEditorViewState;

                translations.forEach(translation => {

                    const index = state.translations.translations.findIndex(t => t.tId === translation.tId);

                    if (updatedLanguages && updatedLanguages.length > 0) {
                        updatedLanguages.forEach(lang => {

                            if (translation.translationsPerLanguage.hasOwnProperty(lang)) {
                                let { label, value } = translation.translationsPerLanguage[lang];

                                if ((index <= 0 || (state.translations.translations[index].translationsPerLanguage[lang] && state.translations.translations[index].translationsPerLanguage[lang].value.custom !== value.custom)) && (state.translationSettings.autoRemove || state.translationSettings.setReviewed)) {

                                    if (label && label.name === 'translate') {
                                        translation.translationsPerLanguage[lang].label = null;
                                    }
                                    if ((!label || label.name !== 'review') && state.translationSettings.setReviewed) {
                                        translation.translationsPerLanguage[lang].label = state.filterLabels.find(label => label.name === 'review');
                                    }
                                }
                            }
                        });
                    }

                    if (index >= 0)
                        state.translations.translations[index] = translation;
                    else
                        state.translations.translations = [translation as Translation].concat(state.translations.translations);

                    this.props.context.onSelectedTranslationUpdate(translation);
                });
                return state;
            });
        }
    }

    applySettings = (action: string, value: boolean) => {
        switch (action) {
            case 'autoRemove':
                localStorage.setItem(action, JSON.stringify(value));
                this.setState(state => {
                    state.translationSettings.autoRemove = value;
                    return state;
                });
                break;
            case 'setReviewed':
                localStorage.setItem(action, JSON.stringify(value));
                this.setState(state => {
                    state.translationSettings.setReviewed = value;
                    return state;
                });
                break;
            case 'removeAllTranslate':
                this.setState(state => {
                    let { translations } = state.translations;
                    for (let t of translations) {
                        for (let lang of Object.keys(t.translationsPerLanguage)) {
                            if (t.translationsPerLanguage[lang].label && t.translationsPerLanguage[lang].label.iconName === 'pencil') {
                                t.translationsPerLanguage[lang].label = null;
                            }
                        }
                    }
                    state.translations.translations = translations;
                    return state;
                });
                break;
            case 'removeAllReviewed':
                this.setState(state => {
                    let { translations } = state.translations;
                    for (let t of translations) {
                        for (let lang of Object.keys(t.translationsPerLanguage)) {
                            if (t.translationsPerLanguage[lang].label && t.translationsPerLanguage[lang].label.iconName === 'bell') {
                                t.translationsPerLanguage[lang].label = null;
                            }
                        }
                    }
                    state.translations.translations = translations;
                    return state;
                });
                break;
        }
    }

    updateMultiSelect = (prop: string, value: any) => {
        this.setState(currentState => {
            let state = currentState as TranslationEditorViewState;

            switch (prop) {
                case 'selectedId':

                    state.selectedId = value;
                    state.selectedRow = null;
                    break;
                case 'selectedIds':
                    if (includes(value, state.selectedId)) {
                        state.multiSelect.selectedIds = value;
                    }
                    else {
                        state.multiSelect.selectedIds = value;
                        state.selectedId = value && value.length > 0 ? value[value.length - 1] : null;
                        state.selectedRow = null;
                    }
                    break;
                case 'enabled':
                    state.multiSelect.enabled = value;
                    state.multiSelect.selectedIds = [];
                    if (value) {
                        state.selectedId = null;
                        state.selectedRow = null;
                    }
                    break;
                case 'selectAll':
                    for (let id of value) {
                        if (!includes(state.multiSelect.selectedIds, id) && includes(this.filteredIds, id)) {
                            state.multiSelect.selectedIds.push(id);
                        }
                    }
            }

            return state;
        });
    }

    multiSelectSetLabels = (iconName: string) => {
        if (iconName) {
            this.setState(currentState => {
                let state = currentState as TranslationEditorViewState;
                let label: Label;
                switch (iconName) {
                    case 'pencil':
                        label = state.filterLabels.find(label => label.name === 'translate');
                        break;
                    case 'bell':
                        label = state.filterLabels.find(label => label.name === 'review');
                        break;
                    case 'clear':
                        label = null;
                }

                for (let id of state.multiSelect.selectedIds) {
                    let translation = state.translations.translations.find(t => t.tId === id);
                    for (let lang of state.translationFilter.selectedLanguages) {

                        if (!translation.translationsPerLanguage.hasOwnProperty(lang)) {
                            translation.translationsPerLanguage[lang] = {
                                tId: translation.tId,
                                langId: find(state.globalLanguages, 'langCode', lang).langId,
                                langCode: lang,
                                value: {
                                    default: '',
                                    defaultId: null,
                                    custom: null,
                                    customId: null
                                },
                                label: null
                            };
                        }

                        translation.translationsPerLanguage[lang].label = label;
                    }
                    this.props.context.onSelectedTranslationUpdate(translation);
                }
                return state;
            });
        }
    }

    setIds = (prop: string, ids: string[]) => {
        switch (prop) {
            case 'filteredIds':
                this.filteredIds = ids;
                break;
            case 'pageIds':
                this.pageIds = ids;
        }
    }

    openSaveDialog = () => {
        HTTPService.post("TranslationsView/GetRevisions/", this.state.globalModules.map(m => m.moduleId))
            .then(revisions => {

                this.setState({
                    saveDialogOpen: true,
                    saveDialogInit: true,
                    currentRevisions: this.state.globalModules.map(m => {
                        let revision = revisions && revisions.length !== 0 ? revisions.find(r => r.moduleId == m.moduleId) : null;
                        if (revision) {
                            let loadedRevision: Revision = {
                                moduleId: revision.moduleId,
                                revisionsPerLanguage: {}
                            }

                            revision.revisionsPerLanguage.forEach(r => {

                                const langCode = this.state.globalLanguages.find(l => l.langId == r.langId).langCode;
                                loadedRevision.revisionsPerLanguage[langCode] = {
                                    langCode: langCode,
                                    revisionTranslations: r.translationJson ? JSON.parse(r.translationJson) : [],
                                    updateDate: r.updateDate,
                                    userName: r.userName
                                };
                            });
                            return loadedRevision;
                        }

                        return {
                            moduleId: m.moduleId,
                            revisionsPerLanguage: {}
                        } as Revision;
                    })
                });
            });
    }

    closeDialog = (save?: boolean) => {
        this.setState({ saveDialogOpen: false });
        if (save)
            this.props.context.saveTranslations(true);
    }

    render() {
        let editorTranslations = this.props.translations;

        return (
            <div className="editor-view-wrapper" style={{ minWidth: '100%', maxWidth: '100%', minHeight: '100%', maxHeight: '100%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                {
                    ReactDOM.createPortal(
                        <FullHeightContainer>
                            {
                                this.renderSettings()
                            }
                        </FullHeightContainer>,
                        this.props.context.leftDrawerElement[0]
                    )
                }
                {
                    ReactDOM.createPortal(
                        <div title={editorTranslations['WebSMS.TransEditor.ActionActivateTranslations.Title']} className="sheet__reminders" style={{ verticalAlign: 'center', display: 'flex', justifyContent: 'center' }} onClick={this.openSaveDialog}>
                            <div style={{ transform: 'scale(195%)', margin: '0px 10px 0 1px' }}>
                                <i className="fal fa-file-archive fa-fw" aria-hidden="true"></i>
                            </div>
                        </div>,
                        this.props.context.menuSheet.elements.getRemindersRef().parent()[0]
                    )
                }
                {
                    this.renderContent()
                }
            </div>
        );
    }
}

class NewPropertyKeyDialog extends React.Component<NewPropertyKeyDialogProps, NewPropertyKeyDialogState> {

    constructor(props) {
        super(props);

        this.state = {
            propertyKey: "",
            moduleId: null
        };
    }

    componentDidUpdate() {
        if (this.props.init) {
            this.props.onInit();
            this.setState({ propertyKey: 'Cus_' });
        }
    }

    onChange = (event) => {
        const { value } = event.target;
        this.setState({ propertyKey: value });
    }

    onModuleIdChange = (moduleId, _) => {
        this.setState({ moduleId: moduleId });
    }

    saveNewPropertyKey = () => {
        const { propertyKey, moduleId } = this.state;
        this.props.closeDialog(true, propertyKey, moduleId);
    }

    render() {
        const { open, existingKeys, modules, closeDialog, editorTranslations } = this.props;
        const { propertyKey, moduleId } = this.state;

        const dialogProps: DialogProps = {
            title: editorTranslations['WebSMS.TransEditor.DialogNewKey.Header'],
            actions: [
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionCancel'],
                    action: () => closeDialog(false)
                },
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionConfirm'],
                    action: () => {

                        if (this.state.propertyKey && this.state.propertyKey !== "" && this.state.moduleId && !includes(this.props.existingKeys, this.state.propertyKey)) {
                            this.saveNewPropertyKey()
                            return true
                        }
                        return false
                    },
                    primary: true
                }],
            afterClose: () => { if (open) closeDialog(false) },
            maxHeight: '289px'
        };

        const warningMessage = includes(existingKeys, propertyKey) ? editorTranslations['WebSMS.TransEditor.PropertyKeyExists.Warning'] : '';

        if (open) {
            return (
                <Dialog {...dialogProps} open={open}>
                    <div key="settings" style={{ width: '550px', height: '117px', padding: '0 25px 12px 5px', display: "flex", flexDirection: "column" }}>
                        <div style={{ width: '100%', paddingBottom: '12px' }}>
                            <SingleDropDownMenu id={propertyKey} name={editorTranslations['WebSMS.ReportMetadata.App']} dataSource={modules} fieldName="displayName" fieldValue="moduleId" initialValue={moduleId} onSelect={this.onModuleIdChange} position="propertyKey" />
                        </div>
                        <div style={{ width: '100%', paddingBottom: '3px', display: 'flex', flexFlow: 'row', alignItems: 'baseline', marginTop: '15px' }}>
                            <label className="text-field-label" style={{ flex: '0 0 129px', padding: '9px 2px 0 25px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                {editorTranslations['WebSMS.TransEditor.PropertyKey']}
                            </label>
                            <span className="k-input k-textbox k-input-solid k-input-md k-rounded-md">
                                <input type="text" className="k-input-inner" value={propertyKey} onChange={this.onChange} style={{ flex: '1 1 auto' }} />
                            </span>
                        </div>
                        <div className="error-text" style={{ height: '20px', paddingLeft: '130px' }}>
                            <label title={warningMessage} style={{ paddingLeft: '12px', paddingTop: '9px', color: 'red', width: '100%', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', margin: '3px 0' }}>
                                {warningMessage}
                            </label>
                        </div>
                    </div>
                </Dialog>
            );
        }

        return null;
    }
}

class TranslationRevisionDialog extends React.Component<TranslationRevisionDialogProps, TranslationRevisionDialogState> {

    constructor(props) {
        super(props);

        this.state = {
            moduleIds: [] as string[],
            forLabels: [] as string[],
            selectedLanguages: [] as string[],
            filteredTranslationsPerModule: [],
            shownModule: null
        };
    }

    componentDidMount() {
        this.setState(currentState => {
            let state = currentState as TranslationRevisionDialogState;
            state.moduleIds = this.props.globalModules.map(m => m.moduleId);
            state.filteredTranslationsPerModule = this.props.globalModules.map(m => {
                return {
                    moduleId: m.moduleId,
                    revisionTranslations: []
                };
            });
            state.shownModule = state.moduleIds[0];
            state.selectedLanguages = this.props.translationFilter.selectedLanguages;
            return this.filterTranslations(state);
        });
    }

    componentDidUpdate() {
        if (this.props.doInit) {
            this.setState(currentState => {
                let state = currentState as TranslationRevisionDialogState;
                state.selectedLanguages = this.props.translationFilter.selectedLanguages;

                this.props.onInit();
                return this.filterTranslations(state);
            });
        }
    }

    setModule = (moduleId: string, enable: boolean) => {
        this.setState(currentState => {
            let state = currentState as TranslationRevisionDialogState;
            let { moduleIds } = state;

            if (enable) {
                moduleIds.push(moduleId);
            }
            else {
                state.moduleIds = moduleIds.filter(m => m !== moduleId);
            }
            state.shownModule = state.moduleIds.length !== 0 ? state.moduleIds[0] : null;
            return this.filterTranslations(state);
        });
    }

    setLabels = (enable, type: 'review' | 'unlabeled' | 'all') => {
        this.setState(currentState => {
            let state = currentState as TranslationRevisionDialogState;


            if (type === 'all') {
                if (enable) {
                    state.forLabels = [];
                }
                else {
                    state.forLabels = ['review', 'unlabeled'];
                }
            }
            else if (type === 'review' || type === 'unlabeled') {
                let { forLabels } = state;

                if (enable) {
                    forLabels.push(type === 'unlabeled' ? 'unlabeled' : 'review');
                }
                else {
                    if (includes(forLabels, (type === 'unlabeled' ? 'review' : 'unlabeled'))) {
                        state.forLabels = [(type === 'unlabeled' ? 'review' : 'unlabeled')];
                    }
                    else {
                        state.forLabels = [];
                    }
                }

            }
            return this.filterTranslations(state);
        });
    }

    setLanguages = (langCodes) => {
        this.setState(currentState => {
            let state = currentState as TranslationRevisionDialogState;
            state.selectedLanguages = langCodes;
            return state;
        });
    }

    closeDialog = () => {
        this.props.closeDialog();
    }

    filterTranslations = (state: TranslationRevisionDialogState): TranslationRevisionDialogState => {
        const { moduleIds, forLabels } = state;
        let enabledTranslations: Translation[];

        if (forLabels.length === 0) {
            enabledTranslations = this.props.translations;
        }
        else {
            enabledTranslations = [];
            if (forLabels.includes('unlabeled')) {
                enabledTranslations = this.props.translations.filter(t => {
                    for (let lang of Object.keys(t.translationsPerLanguage)) {
                        if (t.translationsPerLanguage[lang].label !== null) {
                            return false;
                        }
                    }
                    return true;
                });
            }
            if (forLabels.includes('review')) {
                enabledTranslations = enabledTranslations.concat(this.props.translations.filter(t => {
                    for (let lang of Object.keys(t.translationsPerLanguage)) {
                        if (t.translationsPerLanguage[lang].label && t.translationsPerLanguage[lang].label.name === 'review') {
                            return true;
                        }
                    }
                    return false;
                }));
            }
        }

        for (let id of moduleIds) {
            state.filteredTranslationsPerModule.find(m => m.moduleId === id).revisionTranslations = enabledTranslations.filter(t => t.moduleIds.includes(id)).map(t => {
                let translation = {
                    tId: t.tId,
                    keys: t.keys.filter(k => k.moduleId === id),
                    translationsPerLanguage: {} as Record<string, string>
                };
                Object.keys(t.translationsPerLanguage).forEach(key => {
                    const value = t.translationsPerLanguage[key].value;
                    if (value.custom && value.custom !== '')
                        translation.translationsPerLanguage[key] = value.custom;
                })
                return translation;
            });
        }

        return state;
    }

    persistTranslations = () => {
        let { editorTranslations, currentRevisions, globalLanguages } = this.props;

        let save = false;

        for (let id of this.state.moduleIds) {
            let revision = this.state.filteredTranslationsPerModule.find(m => m.moduleId === id);
            const prevRevision = currentRevisions.find(r => r.moduleId === revision.moduleId);
            let hasChanges = [];

            const revisionStrings = {
                moduleId: revision.moduleId,
                revisionsPerLanguage: this.state.selectedLanguages.map(lang => {

                    const langId = find(globalLanguages, 'langCode', lang).langId;

                    const revisionsPerLanguage = revision.revisionTranslations.filter(t => {
                        const value = t.translationsPerLanguage[lang];

                        if (!hasChanges.find(l => l === lang) && prevRevision?.revisionsPerLanguage[lang]?.revisionTranslations.find(r => r.tId == t.tId)?.value !== value)
                            hasChanges.push(langId);

                        return value && value !== '';
                    }).map(t => {
                        return {
                            tId: t.tId,
                            keys: t.keys,
                            value: t.translationsPerLanguage[lang]
                        };
                    });

                    return {
                        langId: langId,
                        translationJson: revisionsPerLanguage.length > 0 ? JSON.stringify(revisionsPerLanguage) : null
                    };
                }).filter(r => r.translationJson !== null && hasChanges.find(l => r.langId === l))
            };

            if (revisionStrings.revisionsPerLanguage.length > 0) {
                save = true;

                HTTPService.post("TranslationsView/SaveRevisions/", revisionStrings)
                    .then(revision => {
                        if (revision)
                            NotificationHelper.showSuccessMessage(editorTranslations['WebSMS.TransEditor.SaveRevisionSuccess']
                                .replace('{module}', this.props.globalModules.find(m => m.moduleId === revision.moduleId).displayName)
                            );
                    });
            }
        }

        this.setState(currentState => {
            let state = currentState as TranslationRevisionDialogState;
            state.moduleIds = this.props.globalModules.map(m => m.moduleId);

            return this.filterTranslations(state);
        });
        this.props.closeDialog(save);
    }

    showModule = (event) => {
        this.setState({ shownModule: event.target.id });
    }

    getDefaultTranslationValue = (tId, lang) => {
        return this.props.translations.find(t => t.tId === tId)?.translationsPerLanguage[lang]?.value.default;
    }

    render() {
        const { saveDialogOpen, globalModules, currentRevisions, editorTranslations, globalLanguages } = this.props;
        const { moduleIds, forLabels, selectedLanguages, filteredTranslationsPerModule, shownModule } = this.state;
        const dialogProps: DialogProps = {
            title: editorTranslations['WebSMS.TransEditor.ActionActivateTranslations.Title'],
            actions: [
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionCancel'],
                    action: this.closeDialog
                },
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionConfirm'],
                    action: () => {

                        if (this.state.moduleIds.length > 0 && this.state.selectedLanguages.length > 0) {
                            this.persistTranslations()
                            return true
                        }
                        return false
                    },
                    primary: true
                }],
            afterClose: () => { if (saveDialogOpen) this.props.closeDialog() },
            height: 'calc(100% - 50px)',
            maxHeight: '915px'
        };

        const tabs = moduleIds.map((id, index) => {
            let tabStyle: React.CSSProperties = {
                width: '181px',
                height: '34px',
                borderTop: '1px solid rgb(205, 205, 205)',
                borderBottom: shownModule == id ? '1px solid white' : '1px solid rgb(205, 205, 205)',
                borderLeft: '1px solid rgb(205, 205, 205)',
                cursor: 'pointer',
                padding: '4px 4px 1px 10px',
                color: shownModule == id ? 'black' : '#555555',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                zIndex: 999
            }

            if (index === moduleIds.length - 1) {
                tabStyle.borderRight = '1px solid rgb(205, 205, 205)';
            }

            if (index === 0) {
                tabStyle.borderTopLeftRadius = '0.375rem';
            }
            if (index === moduleIds.length - 1) {
                tabStyle.borderTopRightRadius = '0.375rem';
            }

            const { displayName } = globalModules.find(m => m.moduleId === id);
            if (displayName.length <= 20) {
                tabStyle.display = 'flex';
                tabStyle.justifyContent = 'center';
            }

            return (
                <div id={id} key={id} title={displayName} style={tabStyle} onClick={this.showModule}>
                    {displayName}
                </div>
            );
        });

        const moduleSettings = globalModules.map(m => {
            return <SimpleCheckBox key={m.moduleId} name={editorTranslations['WebSMS.TransEditor.RevisionModuleSelect'].replace('{module}', m.displayName)} position="dialog" initialValue={moduleIds.includes(m.moduleId)} onChange={enable => this.setModule(m.moduleId, enable)} />
        });

        let changes = null;
        if (saveDialogOpen && currentRevisions) {

            const valueProps: React.CSSProperties = {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                padding: '0 4px 0 4px',
                height: '26px',
                maxWidth: '565px',
                backgroundColor: 'rgb(255 140 159)',
                color: 'black'
            }
            const changedValueProps: React.CSSProperties = {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                padding: '0 4px 0 4px',
                height: '26px',
                maxWidth: '565px',
                backgroundColor: 'rgb(128 231 128)',
                color: 'black'
            }

            const currentRevision = currentRevisions.find(r => r.moduleId == shownModule);
            changes = filteredTranslationsPerModule.find(m => m.moduleId == shownModule)?.revisionTranslations.map(t => {

                let isChanged = false;
                let prevValues = [];
                let changedValues = [];

                for (let lang of selectedLanguages) {

                    let prev = currentRevision && currentRevision.revisionsPerLanguage.hasOwnProperty(lang) ? (currentRevision.revisionsPerLanguage[lang].revisionTranslations.find(r => r.tId == t.tId)?.value ?? this.getDefaultTranslationValue(t.tId, lang)) : this.getDefaultTranslationValue(t.tId, lang);
                    const changed = t.translationsPerLanguage.hasOwnProperty(lang) ? t.translationsPerLanguage[lang] : this.getDefaultTranslationValue(t.tId, lang);

                    if (changed != prev) {

                        if (prev && prev !== '') {

                            prevValues.push(
                                <div key={lang} style={{ width: '610px', display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                                    <div key="lang" style={{ width: '40px', height: '26px' }}>{`${lang}: `}</div>
                                    <div title={prev} style={valueProps}>{prev}</div>
                                </div>
                            );
                        }
                        if (changed && changed !== '') {
                            changedValues.push(
                                <div key={lang} style={{ width: '610px', display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                                    <div key="lang" style={{ width: '40px', height: '26px' }}>{`${lang}: `}</div>
                                    <div title={changed} style={changedValueProps}>{changed}</div>
                                </div>
                            );
                        }
                        isChanged = true;
                    }
                }

                if (isChanged) {
                    return (
                        <div key={t.tId} style={{ width: '100%', paddingTop: '6px', display: 'flex', flexDirection: 'column' }}>
                            {
                                prevValues.length > 0 ?
                                    <div key="prev" style={{ width: '100%', backgroundColor: 'rgb(255 195 205)' }}>
                                        <div key="values" style={{ display: 'flex', flexDirection: 'column', paddingLeft: '8px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                            {...prevValues}
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                changedValues.length > 0 ?
                                    <div key="changed" style={{ width: '100%', backgroundColor: 'rgb(201 253 201)' }}>
                                        <div key="values" style={{ display: 'flex', flexDirection: 'column', paddingLeft: '8px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                            {...changedValues}
                                        </div>
                                    </div>
                                    : null
                            }
                        </div>
                    );
                }
                return null;
            });

            const userInfo = [];
            if (currentRevision) {
                for (let lang of selectedLanguages) {
                    if (currentRevision.revisionsPerLanguage.hasOwnProperty(lang)) {
                        const { userName, updateDate } = currentRevision.revisionsPerLanguage[lang];
                        if (userName && updateDate) {

                            const info = editorTranslations['WebSMS.TransEditor.RevisionUserInfo'].replace('{user}', userName).replace('{date}', updateDate)

                            userInfo.push(
                                <div key={`version-${lang}`} style={{ width: '100%', height: '25px', display: 'flex', flexDirection: 'row' }}>
                                    <div key="version-lang" title={lang} style={{ flex: '0 0 28px', height: '25px', fontSize: '14px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                        {lang + ':'}
                                    </div>
                                    <div key={`version-info-${lang}`} title={info} style={{ flex: '1 1 auto', height: '25px', fontSize: '14px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                        {info}
                                    </div>
                                </div>
                            );
                        }
                    }
                }
            }

            return (
                <Dialog {...dialogProps} open={saveDialogOpen}>
                    <div key="settings" style={{ width: '665px', height: (655 + 35 * globalModules.length) + 'px', padding: '0 5px 15px 5px' }}>
                        <div key="table" style={{ width: '100%', paddingTop: '34px', position: 'relative' }}>
                            <div key="tabs" style={{ width: '648px', height: '34px', position: 'absolute', top: '1px', display: 'flex', flexDirection: 'row' }}>
                                {tabs}
                            </div>
                            <div key="changes" style={{ width: '100%', height: '295px', paddingBottom: '5px', border: '1px solid rgb(205, 205, 205)', overflow: 'auto' }}>
                                {changes}
                            </div>
                        </div>
                        {userInfo && userInfo.length > 0 ?
                            <div key="versions" style={{ width: '100%', padding: '4px 0 0 1px' }}>
                                {...userInfo}
                            </div>
                            : null
                        }
                        <div key="modules" style={{ display: 'flex', flexDirection: 'column' }}>
                            <div key="head" style={{ marginBottom: '3px', padding: '5px 0 0 6px', fontWeight: 'initial', color: '#111' }}>
                                {editorTranslations['WebSMS.TransEditor.DialogModuleSettings.Header']}
                            </div>
                            {moduleSettings}
                        </div>
                        <div key="languages" style={{ borderTop: '1px solid rgb(205, 205, 205)', marginTop: '10px', display: 'flex', flexDirection: 'column' }}>
                            <div key="head" style={{ padding: '5px 0 0 6px', fontWeight: 'initial', color: '#111' }}>
                                {editorTranslations['WebSMS.TransEditor.DialogLanguageSettings.Header']}
                            </div>
                            <MultiDropDownMenu name={editorTranslations['WebSMS.Resource.Sprachen']} dataSource={globalLanguages} fieldName="displayName" fieldValue="langCode" initialValue={this.state.selectedLanguages} onSelect={this.setLanguages} />
                        </div>
                        <div key="labels" style={{ borderTop: '1px solid rgb(205, 205, 205)', marginTop: '5px', paddingBottom: '10px', display: 'flex', flexDirection: 'column' }}>
                            <div key="head" style={{ marginBottom: '3px', padding: '5px 0 0 6px', fontWeight: 'initial', color: '#111' }}>
                                {editorTranslations['WebSMS.TransEditor.DialogLabelSettings.Header']}
                            </div>
                            <SimpleCheckBox key="all" name={editorTranslations['WebSMS.TransEditor.DialogLabelSettings.Setting1']} position="dialog" initialValue={forLabels && forLabels.length === 0} onChange={bool => this.setLabels(bool, 'all')} />
                            <SimpleCheckBox key="unlabeled" name={editorTranslations['WebSMS.TransEditor.DialogLabelSettings.Setting2']} position="dialog" initialValue={forLabels && forLabels.includes('unlabeled')} onChange={bool => this.setLabels(bool, 'unlabeled')} />
                            <SimpleCheckBox key="review" name={editorTranslations['WebSMS.TransEditor.DialogLabelSettings.Setting3']} position="dialog" initialValue={forLabels && forLabels.includes('review')} onChange={bool => this.setLabels(bool, 'review')} />
                        </div>
                    </div>
                </Dialog>
            );
        }

        return null;
    }
}

class TranslationSearchFilter extends React.Component<TranslationSearchFilterProps> {

    constructor(props) {
        super(props);
    }

    onModuleSelection = (outputModules) => {
        this.props.onChange('selectedModules', outputModules.map(id => find(this.props.globalModules, 'moduleId', id)));
    }

    onLabelSelection = (id) => {
        this.props.onChange('selectedLabel', find(this.props.labels, 'labelId', id));
    }

    onLanguageSelection = (langCodes) => {
        this.props.onChange('selectedLanguages', langCodes);
    }

    onSearchValueChange = (value: string) => {
        this.props.onChange('searchValue', value);
    }

    render() {
        let { labels, editorTranslations } = this.props;
        labels = labels.filter(label => label.labelId !== "-2");

        return (
            <div className="search-filter-wrapper">
                <MultiDropDownMenu name={editorTranslations['WebSMS.ReportMetadata.Apps']} dataSource={this.props.globalModules} fieldName="displayName" fieldValue="moduleId" margin="5px" position="filter" initialValue={this.props.currentFilter.selectedModules.map(m => m.moduleId)} onSelect={this.onModuleSelection} />
                <SingleDropDownMenu id={'labels'} name={editorTranslations['WebSMS.TransEditor.Labels']} dataSource={labels} fieldName="name" fieldValue="labelId" initialValue={this.props.currentFilter.selectedLabel.labelId} position="filter" onSelect={this.onLabelSelection} />
                <MultiDropDownMenu name={editorTranslations['WebSMS.Resource.Sprachen']} dataSource={this.props.globalLanguages} fieldName="displayName" fieldValue="langCode" position="filter" initialValue={this.props.currentFilter.selectedLanguages} onSelect={this.onLanguageSelection} />
                <SearchBar name={editorTranslations['Standard.Suchen']} onSubmit={this.onSearchValueChange} editorTranslations={editorTranslations} />
            </div>
        );
    }
}

class SearchBar extends React.Component<SearchBarProps, any> {

    constructor(props) {
        super(props);
        this.state = {
            searchValue: ""
        };
    }

    onChange = (event) => {
        this.setState({
            searchValue: event.target.value
        });
        this.props.onSubmit(event.target.value);
    }

    onSubmit = (event) => {
        this.props.onSubmit(this.state.searchValue);
    }

    onClear = (event) => {
        this.setState({
            searchValue: ""
        });
        this.props.onSubmit("");
    }

    render() {
        const { name, editorTranslations } = this.props;
        const clearButtonProps: ButtonProps = {
            handleClick: this.onClear,
            iconName: "xmark",
            iconStyle: {
                fontWeight: "bold",
            },
            title: editorTranslations['WebSMS.TransEditor.ActionClear'],
            buttonStyle: {
                borderRadius: "0.375rem",
                border: "1px solid rgb(181 188 195)",
                color: "rgb(181 188 195)",
                marginLeft: '10px'
            }
        }

        return (
            <div className="search-bar-wrapper" style={{ minWidth: '100%', maxWidth: '100%', display: 'flex', flexFlow: 'row', marginBottom: '5px', paddingRight: '6px' }}>
                <label className="text-field-label" title={name} style={{ flex: '0 0 135px', padding: '13px 3px 0 25px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                    {name}
                </label>
                <span className="k-input k-textbox k-input-solid k-input-md k-rounded-md" style={{ marginLeft: '2px' }} >
                    <input
                        type="text"
                        className="k-input-inner"
                        value={this.state.searchValue}
                        onChange={this.onChange}
                        style={{ flex: '1 1 auto' }} />
                </span>
                <div style={{ flex: '0 0 68px' }}>
                    <Button {...clearButtonProps} />
                </div>
            </div>
        );
    }
}

class TranslationSettings extends React.Component<TranslationSettingsProps> {

    constructor(props) {
        super(props);
    }

    setAutoRemove = (autoRemove: boolean) => {
        this.props.onChange('autoRemove', autoRemove);
    }

    setReviewed = (set: boolean) => {
        this.props.onChange('setReviewed', set);
    }

    removeAllTranslate = (event) => {
        this.props.onChange('removeAllTranslate');
    }

    removeAllReviewed = (event) => {
        this.props.onChange('removeAllReviewed');
    }

    render() {
        const { editorTranslations } = this.props;
        const { autoRemove, setReviewed } = this.props.settings;

        return (
            <div className="translation-settings-wrapper" style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ fontWeight: 550, margin: '22px 0 5px 15px', paddingRight: '5px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                    {editorTranslations['WebSMS.TransEditor.EditorSettings.Header']}
                </div>
                <SimpleCheckBox name={editorTranslations['WebSMS.TransEditor.EditorSettings.Setting1']} title={editorTranslations['WebSMS.TransEditor.EditorSettings.Setting1Title']} initialValue={autoRemove} onChange={this.setAutoRemove} />
                <SimpleCheckBox name={editorTranslations['WebSMS.TransEditor.EditorSettings.Setting2']} title={editorTranslations['WebSMS.TransEditor.EditorSettings.Setting2Title']} initialValue={setReviewed} onChange={this.setReviewed} />
                <div style={{ margin: '15px 0 10px 20px' }}>
                    <button className="k-button k-grid" type="button" title={editorTranslations['WebSMS.TransEditor.EditorSettings.Action1']} style={{ minWidth: '95px', height: '36px', padding: '0 12px 0 8px', display: 'flex', flexDirection: 'row', borderRadius: '0.375rem' }} onClick={this.removeAllTranslate}>
                        <FAIcon name={'pencil'} prefix={"fal"} />
                        {editorTranslations['WebSMS.TransEditor.ActionClear']}
                    </button>
                </div>
                <div style={{ marginLeft: '20px' }}>
                    <button className="k-button k-grid" type="button" title={editorTranslations['WebSMS.TransEditor.EditorSettings.Action2']} style={{ minWidth: '95px', height: '36px', padding: '0 12px 0 8px', display: 'flex', flexDirection: 'row', borderRadius: '0.375rem' }} onClick={this.removeAllReviewed}>
                        <FAIcon name={'bell'} prefix={"fal"} />
                        {editorTranslations['WebSMS.TransEditor.ActionClear']}
                    </button>
                </div>
            </div>
        );
    }
}

class TranslationImportExport extends React.Component<TranslationImportExportProps, TranslationImportExportState> {

    constructor(props) {
        super(props);

        this.state = {
            format: localStorage.getItem('format') as 'csv' | 'xlsx' | 'json' ?? 'xlsx',
            selectedOnly: false,
            selectedLanguages: [] as string[],
            importDialogOpen: false,
            confirmationDialogOpen: false
        };

        this.fileInputRef = React.createRef();
    }

    importedTranslations: any[] = null;
    fileInputRef: any = null;

    componentDidMount() {
        this.setState({
            selectedLanguages: this.props.selectedLanguages
        });
    }

    componentDidUpdate(prevProps) {
        let state = {} as any;
        let update = false;
        if (!this.props.multiSelect && this.state.selectedOnly) {
            state.selectedOnly = false;
            update = true;
        }
        if (this.props.selectedLanguages.length !== 0 && !arraysEqual(prevProps.selectedLanguages, this.props.selectedLanguages, '')) {
            state.selectedLanguages = this.props.selectedLanguages;
            update = true;
        }

        if (update) this.setState(state);
    }

    setSelected = (value: boolean) => {
        this.setState({
            selectedOnly: value
        });
    }

    setFormat = (value: 'csv' | 'xlsx' | 'json') => {
        localStorage.setItem('format', value);
        this.setState({
            format: value
        });
    }

    setLanguages = (langCodes) => {
        this.setState({
            selectedLanguages: langCodes
        });
    }

    initiateExport = () => {
        const { editorTranslations } = this.props;

        if (this.state.selectedLanguages.length === 0) {
            NotificationHelper.showErrorMessage(editorTranslations['WebSMS.TransEditor.NoLanguageSelected.Error']);
        }
        else {
            if (!this.state.selectedOnly) {
                this.setState({ confirmationDialogOpen: true });
            }
            else {
                this.exportTranslations();
            }
        }
    }

    closeConfirmDialog = (action) => {
        if (action == 'continue')
            this.exportTranslations();
        this.setState({ confirmationDialogOpen: false });
    }

    exportTranslations = () => {
        const { format, selectedLanguages, selectedOnly } = this.state;
        const { selectedIds } = this.props;
        let translations = this.props.translations;

        if (selectedOnly) {
            let selectedTranslations = [];
            for (let id of selectedIds) {
                selectedTranslations.push(find(translations, 'tId', id));
            }
            translations = selectedTranslations;
        }

        const exportTranslations = translations.map(t => {
            let translation = {
                tId: t.tId,
                translationsPerLanguage: {} as Record<string, string>
            };
            Object.keys(t.translationsPerLanguage).forEach(key => {
                const value = t.translationsPerLanguage[key].value;
                translation.translationsPerLanguage[key] = value.custom && value.custom !== '' ? value.custom : value.default;
            })
            return translation;
        });

        switch (format) {
            case 'xlsx':
                this.exportXLSX(exportTranslations, selectedLanguages);
                break;
            case 'csv':
                this.exportCSV(exportTranslations, selectedLanguages);
                break;
            case 'json':
                this.exportJSON(exportTranslations, selectedLanguages);
                break;
        }
    }

    exportCSV = (translations: any[], languages: string[]) => {
        let csvRows = [];

        let headers = 'id';
        for (let lang of languages) {
            headers += `;${lang}`;
        }
        csvRows.push(headers);

        for (let t of translations) {
            let values = t.tId;

            for (let lang of languages) {
                let value = '';
                if (t.translationsPerLanguage.hasOwnProperty(lang) && t.translationsPerLanguage[lang]) {

                    value = t.translationsPerLanguage[lang];

                    //Das Semikolon wird ersetzt, da es keine zuverlässige Möglichkeit gibt, es zu escapen, ohne andere Satzzeichen zu beeinflussen. Das Semikolon wird derzeit in keiner Übersetzung verwendet (zum Zeitpunkt 11.02.2024).
                    value = value.replace(/\n/g, '\\n').replace(/\r/g, '').replace(/;/g, '.');
                }
                values += ';' + value;
            }
            csvRows.push(values);
        }
        const csvData = csvRows.join('\n');

        let url = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvData);

        const a = document.createElement('a');
        a.setAttribute('href', url);
        const date = new Date();
        a.setAttribute('download', 'translations-' + date.toLocaleDateString() + '-' + date.getHours() + '-' + date.getMinutes() + '.csv');
        a.click();
        a.remove();
    }

    exportJSON = (translations: any[], languages: string[]) => {
        let fileContent = translations.map(t => {
            let obj = {
                id: t.tId
            };
            for (let lang of languages) {
                obj[lang] = t.translationsPerLanguage.hasOwnProperty(lang) ? t.translationsPerLanguage[lang] : null;
            }
            return obj;
        });

        let file = new Blob([JSON.stringify(fileContent)], { type: 'application/json' });
        const url = window.URL.createObjectURL(file);

        const a = document.createElement('a');
        a.setAttribute('href', url);
        const date = new Date();
        a.setAttribute('download', 'translations-' + date.toLocaleDateString() + '-' + date.getHours() + '-' + date.getMinutes() + '.json');
        a.click();
        a.remove();
    }

    exportXLSX = (translations: any[], languages: string[]) => {

        const defaultWidth = 250;
        const columnsWidth: kendo.ooxml.WorkbookSheetColumn[] = [{ width: defaultWidth }, ...languages.map(_ => { return { width: defaultWidth } })];

        const headerRow: kendo.ooxml.WorkbookSheetRow = { cells: [{ value: 'id', bold: true }, ...languages.map(lang => { return { value: lang, bold: true } })] };
        const workbookRows: kendo.ooxml.WorkbookSheetRow[] = [headerRow];

        for (let t of translations) {

            workbookRows.push({
                cells: [
                    { value: t.tId.toString() },
                    ...languages.map(lang => { return { value: t.translationsPerLanguage.hasOwnProperty(lang) ? t.translationsPerLanguage[lang] : '' } })
                ]
            });
        }

        let workbook = new kendo.ooxml.Workbook({
            sheets: [
                {
                    columns: columnsWidth,
                    title: "translations",
                    rows: workbookRows
                }
            ]
        });

        var dataURL = workbook.toDataURL();

        const date = new Date();
        kendo.saveAs({
            dataURI: dataURL,
            fileName: 'translations-' + date.toLocaleDateString() + '-' + date.getHours() + '-' + date.getMinutes() + '.xlsx'
        });
    }

    importTranslations = (input) => {
        const { editorTranslations } = this.props;
        const { files } = input.target;
        let file: File = files && files.length > 0 ? files[0] : null;

        if (file) {

            const fileName = file.name.split(".");
            const extension = fileName[fileName.length - 1];
            let content = null;

            let reader = new FileReader();
            reader.readAsText(file, "UTF-8,%EF%BB%BF");

            reader.onload = (event) => {
                content = event.target.result;

                switch (extension) {
                    case 'xlsx':
                        this.importXLSX(file);
                        break;
                    case 'csv':
                        this.importCSV(content);
                        break;
                    case 'json':
                        this.importJSON(content);
                        break;
                    default:
                        NotificationHelper.showErrorMessage(editorTranslations['WebSMS.TransEditor.ImportExtension.Error'].replace('{extension}', extension));
                }
            }
        }
        else {
            NotificationHelper.showErrorMessage(editorTranslations['WebSMS.TransEditor.ImportNoFile.Error']);
        }

        input.target.value = null;
    }

    importXLSX = (file: File) => {
        const { editorTranslations } = this.props;

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (event) => {

            const content = event.target.result;

            const workbook = XLSX.read(content);

            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const raw_data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            let langList = raw_data[0].slice(1);
            let importedTranslations = [];

            for (let i = 1; i < raw_data.length; i++) {

                if (raw_data[i].length > 0) {
                    let values = raw_data[i];
                    let importedTranslation = {
                        tId: values[0],
                        translationsPerLanguage: {} as Record<string, string>
                    } as any;

                    let translationValues = values.slice(1);
                    translationValues.forEach((value, index) => {
                        importedTranslation.translationsPerLanguage[langList[index]] = value;
                    });

                    if (this.props.translations.find(t => t.tId === values[0]))
                        importedTranslations.push(importedTranslation);
                    else
                        NotificationHelper.showErrorMessage(editorTranslations['WebSMS.TransEditor.ImportNoFound.Error'].replace('{id}', importedTranslation.tId));
                }
            }
            this.openDialog(importedTranslations);
        }
    }

    importCSV = (content) => {
        const { editorTranslations } = this.props;

        if (content) {
            let importedTranslations = [];

            let translationRows = content.split('\n');
            let langList = translationRows[0].split(';').slice(1) as string[];

            for (let i = 1; i < translationRows.length; i++) {

                if (translationRows[i] !== '') {
                    let values = translationRows[i].split(';');
                    let importedTranslation = {
                        tId: values[0],
                        translationsPerLanguage: {} as Record<string, string>
                    } as any;

                    let translationValues = values.slice(1);
                    if (translationValues.length !== langList.length) {

                        let restoredValues = [];
                        for (let l = 0; l < translationValues.length; l += translationValues.length / langList.length) {
                            restoredValues.push(translationValues[l] + ';' + translationValues[l + 1]);
                        }
                        translationValues = restoredValues;
                    }

                    for (let j = 0; j < translationValues.length; j++) {

                        let value = translationValues[j];

                        value = value.replace(/\\n/g, '\n').replace('\r', '').replace(/""/g, '"');
                        if (value.startsWith('"') && value.endsWith('"'))
                            value = value.slice(1, -1);

                        importedTranslation.translationsPerLanguage[langList[j].replace('\r', '')] = value;
                    }

                    if (this.props.translations.find(t => t.tId === values[0]))
                        importedTranslations.push(importedTranslation);
                    else
                        NotificationHelper.showErrorMessage(editorTranslations['WebSMS.TransEditor.ImportNoFound.Error'].replace('{id}', importedTranslation.tId));
                }
            }
            this.openDialog(importedTranslations);
        }
    }

    importJSON = (content) => {
        const { editorTranslations } = this.props;

        if (content) {
            let parsedContent = JSON.parse(content);
            let importedTranslations = [];

            for (let translation of parsedContent) {
                let importedTranslation = {} as any;
                importedTranslation.translationsPerLanguage = {} as Record<string, string>;
                for (let key of Object.keys(translation)) {
                    if (key === 'id') {
                        importedTranslation['tId'] = translation.id;
                    }
                    else {
                        importedTranslation.translationsPerLanguage[key] = translation[key];
                    }
                }

                if (this.props.translations.find(t => t.tId === translation.id))
                    importedTranslations.push(importedTranslation);
                else
                    NotificationHelper.showErrorMessage(editorTranslations['WebSMS.TransEditor.ImportNoFound.Error'].replace('{id}', translation.id));
            }
            this.openDialog(importedTranslations);
        }
    }

    openDialog = (translations) => {
        this.importedTranslations = translations;
        this.setState({
            importDialogOpen: true
        });
    }

    closeDialog = (apply: boolean, languages?: string[]) => {
        if (apply) {
            this.applyImport(languages);
        }
        this.setState({ importDialogOpen: false });
    }

    applyImport = (languages: string[]) => {
        const { editorTranslations, globalLanguages } = this.props;

        const translations = JSON.parse(JSON.stringify(this.props.translations));
        let updatedTranslations = [];

        for (let translation of this.importedTranslations) {
            let targetTranslation = translations.find(t => t.tId === translation.tId);

            if (targetTranslation) {

                let updateCount = 0;
                languages.forEach(lang => {
                    let value = targetTranslation.translationsPerLanguage[lang]?.value;
                    const updateValue = translation.translationsPerLanguage[lang];
                    if (updateValue !== '' && updateValue.replace(/\r/g, '').replace(/\t/g, '') !== (value ? value.custom?.replace(/\r/g, '').replace(/\t/g, '') ?? value.default.replace(/\r/g, '').replace(/\t/g, '') : null)) {

                        if (!targetTranslation.translationsPerLanguage.hasOwnProperty(lang)) {
                            targetTranslation.translationsPerLanguage[lang] = {
                                tId: translation.tId,
                                langId: find(globalLanguages, 'langCode', lang).langId,
                                langCode: lang,
                                value: {
                                    default: '',
                                    defaultId: null,
                                    custom: null,
                                    customId: null
                                },
                                label: null
                            };
                        }

                        targetTranslation.translationsPerLanguage[lang].value.custom = updateValue.trim();
                        updateCount++;
                    }
                });

                if (updateCount > 0) updatedTranslations.push(targetTranslation);
            }
            else {
                NotificationHelper.showErrorMessage(editorTranslations['WebSMS.TransEditor.ImportNoFound.Error'].replace('{id}', translation.tId));
            }
        }

        this.props.replaceTranslations(updatedTranslations, languages);
        NotificationHelper.showSuccessMessage(editorTranslations['WebSMS.TransEditor.ImportTranslations.Success'].replace('{count}', '' + updatedTranslations.length));
    }

    render() {
        const { format, selectedOnly, importDialogOpen, selectedLanguages, confirmationDialogOpen } = this.state;
        const { multiSelect, translations, editorTranslations, globalLanguages } = this.props;
        const formats = [
            {
                name: 'xlsx'
            },
            {
                name: 'csv'
            },
            {
                name: 'json'
            }
        ];
        const dialogProps: DialogProps = {
            title: editorTranslations['WebSMS.TransEditor.Attention.Header'],
            actions: [
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionCancel'],
                    action: () => this.closeConfirmDialog('cancel')
                },
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionConfirm'],
                    action: () => this.closeConfirmDialog('continue'),
                    primary: true
                }],
            afterClose: () => { if (this.state.confirmationDialogOpen) this.setState({ confirmationDialogOpen: false }) },
            maxHeight: '248px'
        };

        return (
            <div className="translation-import-export-wrapper" style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ fontWeight: 550, margin: '24px 0 5px 15px', paddingRight: '5px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                    {editorTranslations['WebSMS.Reporting.ImportExport']}
                </div>
                <div style={{ padding: '15px 15px 2px 20px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                    {editorTranslations['WebSMS.TransEditor.FileFormat']}
                </div>
                <SingleDropDownMenu id={'typeSelection'} name="" dataSource={formats} fieldName="name" fieldValue="name" position="drawer" initialValue={format} onSelect={this.setFormat} />
                <div style={{ padding: '15px 15px 2px 20px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                    {editorTranslations['WebSMS.TransEditor.ImportLangSelect']}
                </div>
                <MultiDropDownMenu name={null} dataSource={this.props.globalLanguages} position="drawer" margin="4px" fieldName="displayName" fieldValue="langCode" initialValue={selectedLanguages} onSelect={this.setLanguages} />
                <SimpleCheckBox name={editorTranslations['WebSMS.TransEditor.ExportSelectedOnly']} title={editorTranslations['WebSMS.TransEditor.ExportSelectedOnlyTitle']} disabled={!multiSelect} initialValue={selectedOnly} onChange={this.setSelected} />
                <div style={{ width: '115px', margin: '10px 0 10px 20px' }}>
                    <button className="k-button k-grid" type="button" title={editorTranslations['WebSMS.TransEditor.ExportDownloadFile']} style={{ minWidth: '95px', height: '36px', padding: '0 12px 0 8px', display: 'flex', flexDirection: 'row', borderRadius: '0.375rem' }} onClick={this.initiateExport}>
                        <FAIcon name={'file-download'} prefix={"fal"} />
                        {editorTranslations['WebSMS.TransEditor.ActionExport']}
                    </button>
                </div>
                <div id="import" style={{ width: '115px', margin: '0 0 0 10px' }}>
                    <button className="k-button k-grid" title={editorTranslations['WebSMS.TransEditor.ImportFile.Title']} style={{ minWidth: '95px', margin: '0 10px', height: '36px', padding: '0 12px 0 8px', display: 'flex', flexDirection: 'row', borderRadius: '0.375rem' }} onClick={_ => this.fileInputRef.current.click()} >
                        <input type="file" style={{ display: 'none' }} onChange={this.importTranslations} ref={this.fileInputRef} />
                        <FAIcon name={'file-import'} prefix={"fal"} />
                        <div>
                            {editorTranslations['WebSMS.TransEditor.ActionImport']}
                        </div>
                    </button>
                </div>
                {
                    this.importedTranslations ?
                        <TranslationImportDialog importDialogOpen={importDialogOpen} importedTranslations={this.importedTranslations} translations={translations} globalLanguages={globalLanguages} closeDialog={this.closeDialog} editorTranslations={editorTranslations} />
                        : null
                }
                <Dialog {...dialogProps} open={confirmationDialogOpen}>
                    <div style={{ width: '420px', height: '50px', padding: '0 5px 12px 5px', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ paddingLeft: '8px' }}>
                            {editorTranslations['WebSMS.TransEditor.DialogExportConfirm.Warning']}
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

class TranslationImportDialog extends React.Component<TranslationImportDialogProps, TranslationImportDialogState> {

    constructor(props) {
        super(props);

        this.state = { selectedLanguages: [] };
    }

    componentDidMount() {
        this.setState({
            selectedLanguages: Object.keys(this.props.importedTranslations[0].translationsPerLanguage)
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.importDialogOpen && !prevProps.importDialogOpen) {
            this.setState({
                selectedLanguages: Object.keys(this.props.importedTranslations[0].translationsPerLanguage)
            });
        }
    }

    getImportLanguages = () => {
        return Object.keys(this.props.importedTranslations[0].translationsPerLanguage).map(c => this.props.globalLanguages.find(l => l.langCode === c));
    }

    setLanguages = (langCodes) => {
        this.setState({
            selectedLanguages: langCodes
        });
    }

    closeDialog = (action) => {
        const { selectedLanguages } = this.state;

        if (action == 'apply') {
            if (selectedLanguages.length > 0)
                this.props.closeDialog(true, selectedLanguages);
            else {
                NotificationHelper.showErrorMessage(this.props.editorTranslations['WebSMS.TransEditor.ImportLangNotMatching.Error']);
                return false;
            }
        }
        else
            this.props.closeDialog(false);

        return true;
    }

    render() {
        const { translations, importedTranslations, importDialogOpen, editorTranslations } = this.props;
        const { selectedLanguages } = this.state;
        const dialogProps: DialogProps = {
            title: editorTranslations['WebSMS.TransEditor.DialogApplyImport'],
            actions: [
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionCancel'],
                    action: () => this.closeDialog('cancel')
                },
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionApply'],
                    action: () => this.closeDialog('apply'),
                    primary: true
                }],
            afterClose: () => { if (importDialogOpen) this.props.closeDialog(false) },
            height: 'calc(100% - 50px)',
            maxHeight: '683px'
        };

        let changes = null;
        changes = importedTranslations.map(t => {
            const prevTranslation = translations.find(i => i.tId == t.tId);

            let isChanged = false;
            let prevValues = [];
            let changedValues = [];
            const valueStyle: React.CSSProperties = {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                padding: '0 4px 0 4px',
                height: '26px',
                maxWidth: '565px',
                backgroundColor: 'rgb(255 140 159)',
                color: 'black'
            }
            const changedValueStyle: React.CSSProperties = {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                padding: '0 4px 0 4px',
                height: '26px',
                maxWidth: '565px',
                backgroundColor: 'rgb(128 231 128)',
                color: 'black'
            }
            for (let lang of selectedLanguages) {

                const prev = prevTranslation?.translationsPerLanguage[lang];

                const prevValue = prev ? (prev.value.custom && prev.value.custom !== '' ? prev.value.custom : prev.value.default) : null;
                const changedValue = t.translationsPerLanguage[lang];

                if (changedValue && changedValue !== '' && changedValue?.replace(/\r/g, '').replace(/\t/g, '') != prevValue?.replace(/\r/g, '').replace(/\t/g, '')) {

                    if (prevValue && prevValue !== '') {
                        prevValues.push(
                            <div key={`${prevTranslation.tId}.${lang}.prev`} style={{ width: '610px', display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                                <div style={{ width: '40px', height: '26px' }}>{`${lang}: `}</div>
                                <div title={prevValue} style={valueStyle}>{prevValue}</div>
                            </div>
                        );
                    }
                    changedValues.push(
                        <div key={`${prevTranslation.tId}.${lang}.changed`} style={{ width: '610px', display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                            <div style={{ width: '40px', height: '26px' }}>{`${lang}: `}</div>
                            <div title={changedValue} style={changedValueStyle}>{changedValue}</div>
                        </div>
                    );

                    isChanged = true;
                }
            }

            if (isChanged) {
                return (
                    <div key={prevTranslation.tId} style={{ width: '100%', paddingTop: '6px', display: 'flex', flexDirection: 'column' }}>
                        {
                            prevValues.length > 0 ?
                                <div style={{ width: '100%', backgroundColor: 'rgb(255 195 205)' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '8px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                        {...prevValues}
                                    </div>
                                </div>
                                : null
                        }
                        {
                            changedValues.length > 0 ?
                                <div style={{ width: '100%', backgroundColor: 'rgb(201 253 201)' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '8px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                        {...changedValues}
                                    </div>
                                </div>
                                : null
                        }
                    </div>
                );
            }
            return null;
        });

        return (
            <Dialog {...dialogProps} open={importDialogOpen}>
                <div style={{ width: '650px', height: '455px', padding: '0 5px 0 5px' }}>
                    <div style={{ width: '100%', height: '455px', paddingBottom: '5px', border: '1px solid rgb(205, 205, 205)', overflow: 'auto' }}>
                        {changes}
                    </div>
                </div>
                <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column' }}>
                    <MultiDropDownMenu name={editorTranslations['WebSMS.TransEditor.ImportLangSelect']} dataSource={this.getImportLanguages()} fieldName="displayName" fieldValue="langCode" initialValue={this.state.selectedLanguages} onSelect={this.setLanguages} position="dialog" />
                </div>
            </Dialog>
        );
    }
}

class TranslationDevImportExport extends React.Component<TranslationDevImportExportProps, TranslationDevImportExportState> {

    constructor(props) {
        super(props);

        this.state = {
            selectedOnly: false,
            importDialogOpen: false,
            importFile: null
        };

        this.fileInputRef = React.createRef();
    }

    importedTranslations: any[] = null;
    fileInputRef: any = null;

    setSelected = (value: boolean) => {
        this.setState({
            selectedOnly: value
        });
    }

    exportCustomTranslations = () => {
        const { selectedOnly } = this.state;
        const { selectedIds } = this.props;
        let translations = this.props.translations;

        if (selectedOnly) {
            let selectedTranslations = [];
            for (let id of selectedIds) {
                selectedTranslations.push(find(translations, 'tId', id));
            }
            translations = selectedTranslations;
        }

        const exportTranslations = translations.map(t => {
            let translation = {
                keys: t.keys,
                translationsPerLanguage: {} as Record<string, string>
            };
            Object.keys(t.translationsPerLanguage).forEach(key => {
                const value = t.translationsPerLanguage[key].value;
                translation.translationsPerLanguage[key] = value.custom ? value.custom : '';
            })
            return translation;
        });

        let file = new Blob([JSON.stringify(exportTranslations)], { type: 'application/json' });
        const url = window.URL.createObjectURL(file);

        const a = document.createElement('a');
        a.setAttribute('href', url);
        const date = new Date();
        a.setAttribute('download', 'custom-translations-' + date.toLocaleDateString() + '-' + date.getHours() + '-' + date.getMinutes() + '.json');
        a.click();
        a.remove();
    }

    initiateImport = (input) => {
        this.setState({
            importDialogOpen: true,
            importFile: input
        });
    }

    importCustomTranslations = () => {
        const { replaceTranslations, globalLanguages, editorTranslations } = this.props;
        const input = this.state.importFile;

        const { files } = input?.target;
        let file: File = files && files?.length > 0 ? files[0] : null;

        if (input && file) {

            const fileName = file.name.split(".");
            const extension = fileName[fileName.length - 1];

            if (extension === 'json') {

                let content = null;

                let reader = new FileReader();
                reader.readAsText(file, "UTF-8,%EF%BB%BF");

                reader.onload = (event) => {
                    content = event.target.result;

                    if (content) {
                        let parsedContent = JSON.parse(content);
                        let importedTranslations = [] as Translation[];
                        let updatedLanguages = [] as string[];

                        const translations = JSON.parse(JSON.stringify(this.props.translations));
                        let maxId = Math.max(...translations.map(t => Number(t.tId)));
                        for (let translation of parsedContent) {

                            const keys = translation.keys as TranslationPropertyKey[];
                            const updateTranslation = translations.find(t => keys.some(k => t.keys.map(tk => tk.key).includes(k.key)));
                            let importedTranslation: Translation;

                            
                            let isNew = false;

                            if (updateTranslation) {
                                importedTranslation = Object.assign({}, updateTranslation);
                            }
                            else {
                                
                                importedTranslation = {
                                    tId: (++maxId).toString(),
                                    translationKey: null,
                                    keys: [keys[0]],
                                    moduleIds: [keys[0].moduleId],
                                    translationsPerLanguage: {}
                                } as Translation;
                                isNew = true;
                            }

                            let updateCount = 0;
                            for (let lang of Object.keys(translation.translationsPerLanguage)) {
                                if (translation.translationsPerLanguage[lang] !== '') {

                                    if (!importedTranslation.translationsPerLanguage.hasOwnProperty(lang)) {
                                        importedTranslation.translationsPerLanguage[lang] = {
                                            tId: importedTranslation.tId,
                                            langId: find(globalLanguages, 'langCode', lang).langId,
                                            langCode: lang,
                                            value: {
                                                default: '',
                                                defaultId: null,
                                                custom: null,
                                                customId: null
                                            },
                                            label: null
                                        };
                                    }

                                    if (importedTranslation.translationsPerLanguage[lang].value.custom !== translation.translationsPerLanguage[lang]) {
                                        updateCount++;
                                        importedTranslation.translationsPerLanguage[lang].value.custom = translation.translationsPerLanguage[lang];

                                        if (!updatedLanguages.includes(lang)) updatedLanguages.push(lang);
                                    }
                                }
                            }

                            if (isNew || updateCount > 0) importedTranslations.push(importedTranslation);
                        }
                        replaceTranslations(importedTranslations, updatedLanguages);
                    }
                }
            }
            else
                NotificationHelper.showErrorMessage(editorTranslations['WebSMS.TransEditor.ImportExtension.Error'].replace('{extension}', extension));
        }
        else {
            NotificationHelper.showErrorMessage(editorTranslations['WebSMS.TransEditor.ImportNoFile.Error']);
        }

        input.target.value = null;
    }

    render() {
        const { selectedOnly, importDialogOpen } = this.state;
        const { multiSelect, editorTranslations } = this.props;

        const dialogProps: DialogProps = {
            title: editorTranslations['WebSMS.TransEditor.Attention.Header'],
            actions: [
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionCancel'],
                    action: () => {
                        if (this.state.importFile) this.state.importFile.target.value = null;
                        this.setState({ importDialogOpen: false, importFile: null });
                    }
                },
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionContinue'],
                    action: () => {
                        this.setState({ importDialogOpen: false });
                        this.importCustomTranslations();
                    },
                    primary: true
                }],
            afterClose: () => { if (this.state.importDialogOpen) this.setState({ importDialogOpen: false }) },
            height: 'calc(100% - 50px)',
            maxHeight: '248px'
        };

        return (
            <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: '20px' }}>
                <div style={{ fontWeight: 550, margin: '4px 0 0 15px', paddingRight: '5px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                    {editorTranslations['WebSMS.Reporting.ImportExport']}
                </div>
                <div style={{ fontWeight: 550, margin: '2px 0 5px 15px', paddingRight: '5px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                    {editorTranslations['WebSMS.TransEditor.Developers.Header']}
                </div>
                <SimpleCheckBox name={editorTranslations['WebSMS.TransEditor.ExportSelectedOnly']} title={editorTranslations['WebSMS.TransEditor.ExportSelectedOnlyTitle']} disabled={!multiSelect} initialValue={selectedOnly} onChange={this.setSelected} />
                <div style={{ width: '115px', margin: '10px 0 10px 20px' }}>
                    <button className="k-button k-grid" type="button" title={editorTranslations['WebSMS.TransEditor.DevExportTranslations']} style={{ minWidth: '95px', height: '36px', padding: '0 12px 0 8px', display: 'flex', flexDirection: 'row', borderRadius: '0.375rem' }} onClick={this.exportCustomTranslations}>
                        <FAIcon name={'file-download'} prefix={"fal"} />
                        {editorTranslations['WebSMS.TransEditor.ActionExport']}
                    </button>
                </div>
                <div id="import" style={{ width: '115px', margin: '0 0 0 10px' }}>
                    <button className="k-button k-grid" title={editorTranslations['WebSMS.TransEditor.DevImportTranslations']} style={{ minWidth: '95px', margin: '0 10px', height: '36px', padding: '0 12px 0 8px', display: 'flex', flexDirection: 'row', borderRadius: '0.375rem' }} onClick={_ => this.fileInputRef.current.click()} >
                        <input type="file" style={{ display: 'none' }} onChange={this.initiateImport} ref={this.fileInputRef} />
                        <FAIcon name={'file-code'} prefix={"fal"} />
                        <div>
                            {editorTranslations['WebSMS.TransEditor.ActionImport']}
                        </div>
                    </button>
                </div>
                <Dialog {...dialogProps} open={importDialogOpen}>
                    <div style={{ width: '460px', height: '50px', padding: '0 5px 12px 5px', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ paddingLeft: '8px' }}>
                            {editorTranslations['WebSMS.TransEditor.DialogImportWarning1']}
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

class TranslationTable extends React.Component<TranslationTableProps> {

    constructor(props) {
        super(props);
    }

    onPageChange = (pageProp: 'itemsPerPage' | 'pageNumber', value: any) => {
        this.props.selectPage(pageProp, value);
    }

    filterTranslations = (translations: Translations, filter: Filter) => {
        if (translations) {
            const { selectedLanguages, selectedModules, selectedLabel, searchValue } = filter;
            let filteredTranslations = [] as Translation[];

            for (let translation of translations.translations) {
                if (this.hasValuePerLanguage(translation, 'modules', selectedModules, selectedLanguages) && this.hasValuePerLanguage(translation, 'label', selectedLabel, selectedLanguages) && this.hasValuePerLanguage(translation, 'searchValue', searchValue, selectedLanguages)) {
                    filteredTranslations.push(translation);
                }
            }

            this.props.setIds('filteredIds', filteredTranslations.map(t => t.tId));
            return filteredTranslations;
        }
        return null;
    }

    hasValuePerLanguage = (translation: Translation, prop: 'modules' | 'label' | 'searchValue', filterValue: any, languages: string[]): boolean => {

        if (prop === 'modules' && filterValue) {
            if (filterValue.length === 0) {
                return true;
            }
            for (let value of filterValue) {
                if (includes(translation.moduleIds, value.moduleId)) {
                    return true;
                }
            }
        }
        else if (prop === 'label' && filterValue) {
            if (filterValue.labelId === "-1") {
                return true;
            }
            else if (filterValue.labelId === "-3") {
                for (let lang of languages) {
                    if (!translation.translationsPerLanguage.hasOwnProperty(lang) || ((!translation.translationsPerLanguage[lang].value.custom || translation.translationsPerLanguage[lang].value.custom === '') && (!translation.translationsPerLanguage[lang].value.default || translation.translationsPerLanguage[lang].value.default === ''))) {
                        return true;
                    }
                }
            }
            else if (filterValue.labelId === "-4") {
                for (let lang of languages) {
                    if (translation.translationsPerLanguage.hasOwnProperty(lang) && translation.translationsPerLanguage[lang].value.custom && translation.translationsPerLanguage[lang].value.custom !== '') {
                        return true;
                    }
                }
            }
            else {
                for (let lang of languages) {
                    if (translation.translationsPerLanguage.hasOwnProperty(lang) && translation.translationsPerLanguage[lang].label && translation.translationsPerLanguage[lang].label.labelId === filterValue.labelId) {
                        return true;
                    }
                }
            }
        }
        else if (prop === 'searchValue') {
            if (!filterValue || filterValue === '') {
                return true;
            }
            for (let key of translation.keys.map(k => k.key)) {
                if (key.toLowerCase().includes(filterValue.toLowerCase())) {
                    return true;
                }
            }
            for (let lang of languages) {
                if (translation.translationsPerLanguage.hasOwnProperty(lang) && ((translation.translationsPerLanguage[lang].value.default && translation.translationsPerLanguage[lang].value.default.toLowerCase().includes(filterValue.toLowerCase())) || (translation.translationsPerLanguage[lang].value.custom && translation.translationsPerLanguage[lang].value.custom.toLowerCase().includes(filterValue.toLowerCase())))) {
                    return true;
                }
            }
        }
        return false;
    }

    getPage = (translations: Translation[]) => {
        const { pageNumber, itemsPerPage, setIds } = this.props;
        const pageTranslations = translations.slice((pageNumber - 1) * itemsPerPage, (pageNumber * itemsPerPage) - 1 < translations.length ? (pageNumber * itemsPerPage) : translations.length);

        setIds('pageIds', pageTranslations.map(t => t.tId));
        return pageTranslations;
    }

    render() {
        const { tableWidth, pageNumber, itemsPerPage, selectedRow, selectedId, multiSelect, globalLanguages, propertyKeysExtendedIds, selectRow, onSelect, onExtend, onSort, editorTranslations } = this.props;
        const { translations, translationFilter } = this.props;
        let filteredTranslations = this.filterTranslations(translations, translationFilter);
        let pageTranslations = this.getPage(filteredTranslations);

        return (
            <div className="table-wrapper" style={{ flex: '1 1 auto', minHeight: '300px', display: 'flex', flexFlow: 'column', alignItems: 'stretch', borderTop: '1px solid rgb(215, 215, 215)', borderBottom: '1px solid rgb(215, 215, 215)' }}>
                <DataTable tableWidth={tableWidth} languages={translationFilter.selectedLanguages} dataSource={pageTranslations} selectedRow={selectedRow} selectedId={selectedId} multiSelect={multiSelect} globalLanguages={globalLanguages} searchValue={translationFilter.searchValue} propertyKeysExtendedIds={propertyKeysExtendedIds} selectRow={selectRow} onSelect={onSelect} onExtend={onExtend} onSort={onSort} editorTranslations={editorTranslations} />
                <Paginator itemCount={filteredTranslations ? filteredTranslations.length : 0} itemsPerPage={itemsPerPage} pageNumber={pageNumber} onChange={this.onPageChange} editorTranslations={editorTranslations} />
            </div>
        );
    }
}

class DataTable extends React.Component<DataTableProps, DataTableState> {

    constructor(props) {
        super(props);

        this.state = {
            hovered: null
        };
    }

    componentDidUpdate() {
        const { dataSource, selectedId, selectedRow, selectRow, onSelect, multiSelect, propertyKeysExtendedIds, onExtend } = this.props;

        let clearExtensions = false;
        propertyKeysExtendedIds.forEach(id => {
            if (!includes(dataSource.map(t => t.tId), id)) {
                clearExtensions = true;
            }
        });

        if (selectedRow === null && find(dataSource, 'tId', selectedId)) {
            selectRow(findIndex(dataSource, 'tId', selectedId), clearExtensions);
        }
        else if (selectedRow !== null && selectedId === null) {
            onSelect(this.props.dataSource[selectedRow], selectedRow, multiSelect.enabled ? true : false, clearExtensions);
        }
        else if (selectedRow !== null && !find(dataSource, 'tId', selectedId)) {
            selectRow(null, clearExtensions);
        }
        else if (clearExtensions) {
            onExtend(null);
        }
    }

    onSelect = (event) => {
        const { id } = event.target;

        if (id && id !== '')
            this.props.onSelect(this.props.dataSource[id], id);
    }

    onExtend = (event) => {
        const { id } = event.target;

        this.props.onExtend(id);
    }

    getAllLabels = (obj: Translation, languages: string[]) => {
        let labels = [] as Label[];
        for (let lang of languages) {
            if (obj.translationsPerLanguage.hasOwnProperty(lang) && obj.translationsPerLanguage[lang].label && !includes(labels, obj.translationsPerLanguage[lang].label, 'labelId')) {
                labels.push(obj.translationsPerLanguage[lang].label);
            }
        }
        return labels;
    }

    extractIcons = (labels: Label[], index: number) => {
        if (!labels) {
            return null;
        }

        let iconTemplates = [];
        let i = 1;
        if (labels.length !== 0) {
            for (let icon of sort(labels, 'iconName', 'desc')) {
                iconTemplates.push(
                    <div key={i} id={index.toString()} onClick={this.onSelect} title={icon.name} style={{ marginRight: '10px' }}>
                        <FAIcon name={icon.iconName} prefix={"fal"} />
                    </div>
                );
                i++;
            };
        }
        return (
            <div key={index} style={{ minHeight: '36px', maxHeight: '36px', background: this.getBackgroundColor(index) }}>
                <div id={index.toString()} onClick={this.onSelect} style={{ minHeight: '36px', maxHeight: '36px', width: '100%', display: 'flex', flexDirection: 'row', padding: '11px 0 0 10px' }}>
                    {iconTemplates}
                </div>
            </div>
        );
    }

    getBackgroundColor = (index: number) => {
        let { multiSelect, dataSource, selectedRow } = this.props;
        const { hovered } = this.state;
        let { selectedIds, enabled } = multiSelect;

        if (index == selectedRow) {
            return 'rgba(23, 61, 120, 0.26)';
        }
        else if (enabled && includes(selectedIds, dataSource[index].tId)) {
            return hovered !== null && hovered === index ? 'rgba(23, 61, 120, 0.22)' : 'rgba(23, 61, 120, 0.16)';
        }
        else if (hovered !== null && hovered === index) {
            return 'rgb(229 229 229)';
        }
        return index % 2 === 1 ? 'rgb(245, 245, 245)' : 'white';
    }

    getHighlightedText = (index: number, obj: any, substring: string, lang?: string, langIndex?: number) => {

        // empty placeholder if extended
        if (!obj) {
            return (lang === null ?
                <div key={index + langIndex.toString()} style={{ minHeight: '36px', maxHeight: '36px', background: this.getBackgroundColor(index) }}>
                    <div id={index.toString()} onClick={this.onSelect} style={{ minHeight: '36px', maxHeight: '36px' }} />
                </div>
                :
                <div key={index + langIndex.toString()} id={index.toString()} onClick={this.onSelect} style={{ minHeight: '36px', maxHeight: '36px', padding: '11px 0 0 10px', background: this.getBackgroundColor(index) }} />
            );
        }

        if (lang) {
            let translation = obj.translationsPerLanguage;
            const hasLang = translation.hasOwnProperty(lang);
            let translationValue = hasLang ? (translation[lang].value.custom && translation[lang].value.custom !== '' ? translation[lang].value.custom : translation[lang].value.default) : null;

            if (!translationValue || !substring || substring === '' || (!translationValue.toLowerCase().includes(substring.toLowerCase()))) {
                return (
                    <div key={index} id={index.toString()} title={hasLang ? (translation[lang].value.custom && translation[lang].value.custom !== '' ? `${obj.translationsPerLanguage[lang].value.custom} (custom)` : (obj.translationsPerLanguage[lang].value.default !== '' ? `${obj.translationsPerLanguage[lang].value.default} (default)` : '')) : ''} onClick={this.onSelect} style={{ minHeight: '36px', maxHeight: '36px', padding: '11px 10px 0 10px', background: this.getBackgroundColor(index), textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                        {translationValue}
                    </div>
                );
            }
            else {
                const spanStart = translationValue.toLowerCase().indexOf(substring.toLowerCase());
                return (
                    <div key={index} id={index.toString()} title={hasLang ? (translation[lang].value.custom && translation[lang].value.custom !== '' ? `${obj.translationsPerLanguage[lang].value.custom} (custom)` : (obj.translationsPerLanguage[lang].value.default !== '' ? `${obj.translationsPerLanguage[lang].value.default} (default)` : '')) : ''} onClick={this.onSelect} style={{ minHeight: '36px', maxHeight: '36px', padding: '11px 10px 0 10px', background: this.getBackgroundColor(index), textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                        {translationValue.substring(0, spanStart)}
                        <span id={index.toString()} onClick={this.onSelect} style={{ background: 'rgb(204 52 103 / 30%)' }}>{translationValue.substring(spanStart, spanStart + substring.length)}</span>
                        {translationValue.substring(spanStart + substring.length)}
                    </div>
                );
            }
        }
        else { //display propertyKeys
            let extendButton = (obj.keyIndex === 0 && obj.hasMultipleKeys) ? (
                <div key={obj.tId + '.extend'} style={{ flex: '0 0 36px', height: '36px', padding: '10px 0 0 5px', cursor: 'pointer', color: '#999' }}>
                    <span id={obj.tId.toString()} onClick={this.onExtend} className={includes(this.props.propertyKeysExtendedIds, obj.tId) ? 'k-icon k-i-arrow-60-up' : 'k-icon k-i-arrow-60-down'}></span>
                </div>
            ) : (
                <div key={obj.tId + '.placeholder'} id={index.toString()} onClick={this.onSelect} style={{ flex: '0 0 36px' }} />
            );

            if (!substring || substring === '' || !obj.key.toLowerCase().includes(substring.toLowerCase())) {
                return (
                    <div key={obj.keyIndex} title={obj.key} style={{ minHeight: '36px', maxHeight: '36px', width: '100%', display: 'flex', flexDirection: 'row', background: this.getBackgroundColor(index) }}>
                        <div key={obj.tId} id={index.toString()} onClick={this.onSelect} style={{ flex: '1 1 auto', padding: '11px 0 0 10px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                            {obj.key}
                        </div>
                        {extendButton}
                    </div>
                );
            }
            else {
                const spanStart = obj.key.toLowerCase().indexOf(substring.toLowerCase());
                return (
                    <div key={obj.keyIndex} title={obj.key} style={{ minHeight: '36px', maxHeight: '36px', width: '100%', display: 'flex', flexDirection: 'row', background: this.getBackgroundColor(index) }}>
                        <div key={obj.tId} id={index.toString()} onClick={this.onSelect} style={{ flex: '1 1 auto', padding: '11px 0 0 10px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                            {obj.key.substring(0, spanStart)}
                            <span id={index.toString()} onClick={this.onSelect} style={{ background: 'rgb(204 52 103 / 30%)' }}>{obj.key.substring(spanStart, spanStart + substring.length)}</span>
                            {obj.key.substring(spanStart + substring.length)}
                        </div>
                        {extendButton}
                    </div>
                );
            }
        }
    }

    render() {
        const { tableWidth, dataSource, languages, globalLanguages, searchValue, propertyKeysExtendedIds, editorTranslations } = this.props;
        const width = (tableWidth - 560) / (languages.length);
        const columnWidth = tableWidth && width > 400 ? width + 'px' : '400px';

        let body = dataSource.map((obj, index) => {
            let values = [];
            let labels = this.getAllLabels(obj, languages);

            if (searchValue && searchValue !== '') {
                for (let i = 0; i < obj.keys.length; i++) {
                    let propertyKey = obj.keys[i];
                    if (propertyKey.key.toLowerCase().includes(searchValue.toLowerCase())) {
                        obj.keys.splice(i, 1);
                        obj.keys.unshift(propertyKey);
                        break;
                    }
                }
            }

            let isExtended = propertyKeysExtendedIds.includes(obj.tId.toString());
            let hasMultipleKeys = obj.keys.length > 1;

            let labelsTemplate = !isExtended ? this.extractIcons(labels, index) : obj.keys.map((_, idx) => idx === 0 ? this.extractIcons(labels, index) : this.getHighlightedText(index, null, searchValue, null, idx));
            let keysTemplate = !isExtended ? this.getHighlightedText(index, { key: obj.keys[0].key, keyIndex: 0, tId: obj.tId, hasMultipleKeys: hasMultipleKeys }, searchValue) : obj.keys.map((propKey, idx, keys) => this.getHighlightedText(index, { key: propKey.key, keyIndex: idx, tId: obj.tId, hasMultipleKeys: hasMultipleKeys, isLastKey: idx === keys.length - 1, isExtended: true }, searchValue));

            values.push(
                <td key={index + '.labels'} id={index.toString()} onClick={this.onSelect} style={{ width: '95px', verticalAlign: 'top', borderLeft: '1px solid rgb(225, 225, 225)' }}>
                    {labelsTemplate}
                </td>
            );
            values.push(
                <td key={index + '.keys'} style={{ minWidth: '450px', maxWidth: '450px', verticalAlign: 'top', borderLeft: '1px solid rgb(225, 225, 225)' }}>
                    {keysTemplate}
                </td>
            );
            values.push(...languages.map((lang, langIndex) => {
                let translationsTemplate = !isExtended ? this.getHighlightedText(index, obj, searchValue, lang, langIndex) : obj.keys.map((_, idx) => idx === 0 ? this.getHighlightedText(index, obj, searchValue, lang, langIndex) : this.getHighlightedText(index, null, searchValue, '', idx));

                return (
                    <td key={index + '.' + lang} style={{ minWidth: columnWidth, maxWidth: columnWidth, verticalAlign: 'top', borderLeft: '1px solid rgb(225, 225, 225)', borderRight: langIndex === languages.length - 1 ? '1px solid rgb(225, 225, 225)' : '' }}>
                        {translationsTemplate}
                    </td>
                );
            }));

            return (
                <tr key={index.toString()} onMouseEnter={_ => this.setState({ hovered: index })} onMouseLeave={_ => this.setState({ hovered: null })}>
                    {values}
                </tr>
            );
        });

        return (
            <div id="data-table-wrapper" style={{ flex: '1 1 auto', display: 'flex', flexFlow: 'column', alignItems: 'stretch', overflowY: 'auto', tableLayout: 'fixed' }}>
                <table cellSpacing="0" cellPadding="0" style={{ borderLeft: '1px solid rgb(215, 215, 215)' }}>
                    <DataTableSortHeader languages={languages} globalLanguages={globalLanguages} onSort={this.props.onSort} editorTranslations={editorTranslations} />
                    <tbody>
                        {body}
                    </tbody>
                </table>
            </div>
        );
    }
}

class DataTableSortHeader extends React.Component<SortHeaderProps, SortHeaderState> {

    constructor(props) {
        super(props);
        this.state = {
            sortDirection: null,
            sortColumn: null
        }
    }

    onSort = (value) => {
        const { editorTranslations } = this.props;
        const { sortDirection, sortColumn } = this.state;

        if (value !== editorTranslations['WebSMS.TransEditor.Labels']) {
            const column = sortDirection === 'desc' ? null : (value === editorTranslations['WebSMS.TransEditor.PropertyKeys'] ? 'keys' : value);
            const direction = sortDirection === null || sortColumn !== column ? 'asc' : (sortDirection === 'asc' ? 'desc' : null);

            this.setState({
                sortDirection: direction,
                sortColumn: column
            });

            this.props.onSort({
                column: column,
                direction: direction
            });
        }
    }

    render() {
        const { languages, globalLanguages, editorTranslations } = this.props;
        const { sortColumn, sortDirection } = this.state;
        let columns = [editorTranslations['WebSMS.TransEditor.Labels'], editorTranslations['WebSMS.TransEditor.PropertyKeys'], ...languages];

        let header = columns.map((column, index) => {
            return (
                <th key={index.toString()} id={column} onClick={_ => this.onSort(column)} style={{ position: 'sticky', zIndex: 9999, top: '0', minWidth: '85px', cursor: index === 0 ? 'default' : 'pointer', borderLeft: '1px solid rgb(215, 215, 215)', borderRight: '1px solid rgb(215, 215, 215)', boxShadow: '0 2px 2px - 1px rgba(0, 0, 0, 0.4)' }}>
                    <div style={{ minHeight: '36px', maxHeight: '36px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '11px 0 0 18px', borderTop: '1px solid rgb(215, 215, 215)', borderBottom: '1px solid rgb(205, 205, 205)', background: 'rgb(245, 245, 245)', textAlign: 'left', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                        <div style={{ flex: '1 1 auto', paddingLeft: '3px' }}>
                            {includes(languages, column) ? find(globalLanguages, 'langCode', column).displayName : column}
                        </div>
                        <div style={{ flex: '0 0 24px', height: '20px' }}>
                            {sortDirection && (sortColumn === 'keys' ? editorTranslations['WebSMS.TransEditor.PropertyKeys'] : sortColumn) === column ?
                                <FAIcon name={sortDirection === 'asc' ? 'arrow-up fa-light' : 'arrow-down  fa-light'} prefix={"fas"} style={{ color: '#999' }} />
                                : null}
                        </div>
                    </div>
                </th>
            );
        });

        return (
            <thead style={{ zIndex: 9999 }}>
                <tr style={{ minWidth: '100%', maxWidth: '100%' }}>
                    {header}
                </tr>
            </thead>
        );
    }
}

class Paginator extends React.Component<PaginatorProps> {

    constructor(props) {
        super(props);
    }

    selectPage = (event) => {
        const { itemCount, itemsPerPage, pageNumber, onChange } = this.props;
        const maxPage = Math.ceil(itemCount / itemsPerPage);

        switch (event.target.id) {
            case 'endLeft':
                if (pageNumber !== 1) {
                    onChange('pageNumber', 1);
                }
                break;
            case 'arrowLeft':
                if (pageNumber !== 1) {
                    onChange('pageNumber', pageNumber - 1);
                }
                break;
            case 'arrowRight':
                if (pageNumber !== maxPage) {
                    onChange('pageNumber', pageNumber + 1);
                }
                break;
            case 'endRight':
                if (pageNumber !== maxPage) {
                    onChange('pageNumber', maxPage);
                }
                break;
            case 'nextTen':
                onChange('pageNumber', (Math.ceil(pageNumber / 10) * 10) + 1);
                break;
            case 'prevTen':
                onChange('pageNumber', pageNumber % 10 === 0 ? pageNumber - 10 : (Math.floor(pageNumber / 10) * 10));
                break;
            default:
                if (pageNumber != event.target.id) {
                    onChange('pageNumber', Number(event.target.id));
                }
        }
    }

    setItemsPerPage = (value: number) => {
        this.props.onChange('itemsPerPage', value);
        this.props.onChange('pageNumber', 1);
    }

    render() {
        const { itemCount, itemsPerPage, pageNumber, editorTranslations } = this.props;
        const isFirst = pageNumber == 1 || itemCount === 0;
        const isLast = pageNumber == Math.ceil(itemCount / itemsPerPage) || itemCount === 0;
        const maxPage = Math.ceil(itemCount / itemsPerPage);

        const leftPageButtonStyle = {
            width: '39px',
            height: '39px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'black',
            borderRadius: '0.375rem',
            opacity: isFirst ? '0.5' : '1.0',
            cursor: !isFirst ? 'pointer' : 'default'
        };
        const rightPageButtonStyle = {
            width: '39px',
            height: '39px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '0.375rem',
            color: 'black',
            opacity: isLast ? '0.5' : '1.0',
            cursor: !isLast ? 'pointer' : 'default'
        };

        let pages = [];

        const pageButtonStyle = {
            width: '39px',
            height: '39px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }

        if (maxPage <= 10) {
            for (let i = 1; i <= maxPage; i++) {

                let style: React.CSSProperties = pageNumber === i + 1 ? { ...pageButtonStyle, cursor: 'default' } : pageButtonStyle;
                pages.push(

                    <div key={i} style={pageNumber === i ? { backgroundColor: 'rgb(23 61 120 / 20%)', borderRadius: '0.375rem' } : null}>
                        <div id={(i).toString()} className="k-button k-button-md k-button-flat k-button-flat-primary" style={style} onClick={this.selectPage}>
                            {i}
                        </div>
                    </div>
                );
            }
        }
        else {
            if (pageNumber > 10) {
                pages.push(
                    <div key={'prevTen'} id={'prevTen'} className="k-button k-button-md k-button-flat k-button-flat-primary" style={{ width: '39px', height: '39px', paddingTop: '2px', fontSize: 'larger', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'black', cursor: 'pointer' }} onClick={this.selectPage}>
                        {'...'}
                    </div>
                );
            }

            if (pageNumber % 10 === 0) {
                for (let i = pageNumber - 9; i <= pageNumber; i++) {

                    let style: React.CSSProperties = pageNumber === i ? { ...pageButtonStyle, cursor: 'default', borderRadius: '0.375rem' } : pageButtonStyle;
                    pages.push(
                        <div key={i} style={pageNumber === i ? { backgroundColor: 'rgb(23 61 120 / 20%)', borderRadius: '0.375rem' } : null}>
                            <div id={i.toString()} className="k-button k-button-md k-button-flat k-button-flat-primary" style={style} onClick={this.selectPage}>
                                {i}
                            </div>
                        </div>
                    );
                }
            }
            if (pageNumber % 10 !== 0) {
                for (let i = (Math.floor(pageNumber / 10) * 10) + 1; i <= ((Math.ceil(pageNumber / 10) * 10) < maxPage ? (Math.ceil(pageNumber / 10) * 10) : maxPage); i++) {

                    let style: React.CSSProperties = pageNumber === i ? { ...pageButtonStyle, cursor: 'default', borderRadius: '0.375rem' } : pageButtonStyle;
                    pages.push(
                        <div key={i} style={pageNumber === i ? { backgroundColor: 'rgb(23 61 120 / 20%)', borderRadius: '0.375rem' } : null}>
                            <div id={i.toString()} className="k-button k-button-md k-button-flat k-button-flat-primary" style={style} onClick={this.selectPage}>
                                {i}
                            </div>
                        </div>
                    );
                }
            }

            if (pageNumber % 10 === 0 ? pageNumber !== maxPage : pageNumber < (Math.floor((maxPage % 10 === 0 ? maxPage - 1 : maxPage) / 10) * 10)) {
                pages.push(
                    <div key={'nextTen'} id={'nextTen'} className="k-button k-button-md k-button-flat k-button-flat-primary" style={{ width: '39px', height: '39px', paddingTop: '2px', fontSize: 'larger', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'black', cursor: 'pointer' }} onClick={this.selectPage}>
                        {'...'}
                    </div>
                );
            }
        }

        const itemsPerPageOptions = [
            {
                value: 20
            },
            {
                value: 50
            },
            {
                value: 100
            }
        ];

        return (
            <div style={{ flex: '0 0 54px', display: 'flex', flexFlow: 'row', padding: '1px', border: '1px solid rgb(215, 215, 215)' }}>
                <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'row', padding: '5px 0 6px 3px' }}>
                    <div id="endLeft" className="k-pager-nav k-button k-button-flat k-button-flat-base k-icon-button k-button-md" style={leftPageButtonStyle} onClick={this.selectPage}>
                        <span id="endLeft" className="k-icon k-i-arrow-end-left" onClick={this.selectPage} style={{ cursor: !isFirst ? 'pointer' : 'default' }}></span>
                    </div>
                    <div id="arrowLeft" className="k-pager-nav k-button k-button-flat k-button-flat-base k-icon-button k-button-md" style={leftPageButtonStyle} onClick={this.selectPage}>
                        <span id="arrowLeft" className="k-icon k-i-arrow-60-left" onClick={this.selectPage} style={{ cursor: !isFirst ? 'pointer' : 'default' }}></span>
                    </div>
                    {pages}
                    <div id="arrowRight" className="k-pager-nav k-button k-button-flat k-button-flat-base k-icon-button k-button-md" style={rightPageButtonStyle} onClick={this.selectPage}>
                        <span id="arrowRight" className="k-icon k-i-arrow-60-right" onClick={this.selectPage} style={{ cursor: !isLast ? 'pointer' : 'default' }}></span>
                    </div>
                    <div id="endRight" className="k-pager-nav k-button k-button-flat k-button-flat-base k-icon-button k-button-md" style={rightPageButtonStyle} onClick={this.selectPage}>
                        <span id="endRight" className="k-icon k-i-arrow-end-right" onClick={this.selectPage} style={{ cursor: !isLast ? 'pointer' : 'default' }}></span>
                    </div>
                </div>
                <div style={{ flex: '0 0 250px' }}>
                    <SingleDropDownMenu id={'itemsPerPage'} name={editorTranslations['WebSMS.TransEditor.PaginatorItems']} dataSource={itemsPerPageOptions} fieldName="value" fieldValue="value" position="paginator" initialValue={itemsPerPage} onSelect={this.setItemsPerPage} />
                </div>
                <div style={{ flex: '0 0 172px', padding: '1px 12px 0 0', color: 'rgb(115, 115, 115)', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                    {`${((pageNumber - 1) * itemsPerPage) + 1} - ${(pageNumber * itemsPerPage) - 1 < itemCount ? (pageNumber * itemsPerPage) : itemCount} ${editorTranslations['WebSMS.TransEditor.Of']} ${itemCount}`}
                </div>
            </div>
        );
    }
}

class TranslationDetails extends React.Component<TranslationDetailsProps, TranslationDetailsState> {

    constructor(props) {
        super(props);

        this.state = {
            infoDialogOpen: false,
            tableRowHovered: null,
            sortBy: null,
            sortDirection: null
        };
    }

    getSelectedLabel = (lang: string) => {
        let { translation, labels } = this.props;
        if (translation && translation.translationsPerLanguage.hasOwnProperty(lang) && translation.translationsPerLanguage[lang].label) {
            return find(labels, 'labelId', translation.translationsPerLanguage[lang].label.labelId).labelId;
        }
        return '-2';
    }

    getApplications = (translation: Translation) => {
        let { globalModules } = this.props;
        return globalModules ? globalModules.filter(module => includes(translation.moduleIds, module.moduleId)).map(module => module.displayName) : [];
    }

    onValueChange = (value: string, lang: string) => {
        let { translation } = this.props;
        if (translation) {
            translation.translationsPerLanguage[lang].value.custom = value;
            this.props.onChange([translation], [lang]);
        }
    }

    onLabelChange = (value: string, lang: string) => {
        const { translation, labels } = this.props;
        if (translation) {
            if (value === labels[0].labelId) {
                translation.translationsPerLanguage[lang].label = null;
            }
            else {
                translation.translationsPerLanguage[lang].label = find(labels, 'labelId', value);
            }
            this.props.onChange([translation]);
        }
    }

    onSort = (value) => {
        const { sortDirection, sortBy } = this.state;

        const column = sortDirection === 'desc' ? null : value;
        const direction = sortDirection === null || sortBy !== column ? 'asc' : (sortDirection === 'asc' ? 'desc' : null);

        this.setState({
            sortDirection: direction,
            sortBy: column
        });
    }

    render() {
        const { translation, languages, globalLanguages, globalModules, labels, editorTranslations } = this.props;
        const { infoDialogOpen, tableRowHovered, sortDirection, sortBy } = this.state;

        let langEdit = [];
        if (translation) {
            for (let lang of languages) {

                if (!translation.translationsPerLanguage.hasOwnProperty(lang)) {
                    translation.translationsPerLanguage[lang] = {
                        tId: translation.tId,
                        langId: find(globalLanguages, 'langCode', lang).langId,
                        langCode: lang,
                        value: {
                            default: '',
                            defaultId: null,
                            custom: null,
                            customId: null
                        },
                        label: null
                    };
                }

                const { value } = translation.translationsPerLanguage[lang];
                const langName = find(globalLanguages, 'langCode', lang).displayName;

                langEdit.push(
                    <div key={lang} style={{ minWidth: '100%', maxWidth: '100%', display: 'flex', flexDirection: 'row' }}>
                        <div style={{ flex: '1 1 auto' }}>
                            <TranslationValueEditor id={lang} name={langName} initialValue={value.custom} defaultValue={value.default ? value.default : null} onChange={this.onValueChange} editorTranslations={editorTranslations} />
                        </div>
                        <div style={{ flex: '0 0 278px' }}>
                            <SingleDropDownMenu id={lang} name={editorTranslations['WebSMS.TransEditor.Labels']} dataSource={labels} fieldName="name" fieldValue="labelId" initialValue={this.getSelectedLabel(lang)} position="details" onSelect={this.onLabelChange} />
                        </div>
                    </div>
                );
            }
        }

        const infoButtonProps: ButtonProps = {
            handleClick: _ => this.setState({ infoDialogOpen: true }),
            iconName: "info",
            iconStyle: {
                fontWeight: "bold"
            },
            title: editorTranslations['WebSMS.TransEditor.ActionPropertyKeys.Title'],
            buttonStyle: {
                position: "absolute",
                bottom: "-42px",
                left: "25px",
                borderRadius: "0.375rem",
                borderColor: "rgb(181 188 195)"
            }
        }
        const dialogProps: DialogProps = {
            title: editorTranslations['WebSMS.TransEditor.TranslationPropertyKeys'],
            actions: [
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionClose'],
                    action: () => this.setState({ infoDialogOpen: false })
                }],
            afterClose: () => { if (infoDialogOpen) this.setState({ infoDialogOpen: false }) },
            maxHeight: '427px'
        };

        let propertyKeys = translation?.keys.map(key => { return { key: key.key, module: find(globalModules, 'moduleId', key.moduleId).displayName } });
        if (infoDialogOpen) {
            switch (sortBy) {
                case 'value':
                    propertyKeys = propertyKeys.sort((a, b) => {
                        return sortDirection === 'asc' ? a.key.localeCompare(b.key) : b.key.localeCompare(a.key);
                    });
                    break;
                case 'module':
                    propertyKeys = propertyKeys.sort((a, b) => {
                        return sortDirection === 'asc' ? a.module.localeCompare(b.module) : b.module.localeCompare(a.module);
                    });
                    break;
            }
        }
        const columnWidth = translation?.keys.length > 6 ? '421px' : '428px';

        return (
            <div className="details-wrapper" style={{ paddingTop: '10px', position: 'relative' }}>
                <div style={{ minHeight: '47px', maxHeight: '156px', paddingBottom: '9px', overflow: 'auto' }}>
                    {langEdit}
                </div>
                {translation ?
                    <Button {...infoButtonProps} />
                    : null
                }
                <Dialog {...dialogProps} open={infoDialogOpen}>
                    <div id="info-table-wrapper" style={{ width: '861px', height: '261px', overflowY: 'auto', overflowX: 'hidden', margin: '6px', border: '1px solid rgb(215, 215, 215)', borderBottom: '2px solid rgb(215, 215, 215)' }}>
                        <table cellSpacing="0" cellPadding="0">
                            <thead style={{ zIndex: 9999 }}>
                                <tr>
                                    <th key="values" onClick={_ => this.onSort('value')} style={{ position: 'sticky', zIndex: 9999, top: '0', minWidth: '85px', cursor: 'pointer', borderLeft: '1px solid rgb(215, 215, 215)', borderRight: '1px solid rgb(215, 215, 215)', boxShadow: '0 2px 2px - 1px rgba(0, 0, 0, 0.4)' }}>
                                        <div style={{ minHeight: '36px', maxHeight: '36px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '5px 0 0 18px', borderTop: '1px solid rgb(215, 215, 215)', borderBottom: '1px solid rgb(205, 205, 205)', background: 'rgb(245, 245, 245)', textAlign: 'left', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                            <div style={{ flex: '1 1 auto', paddingLeft: '3px' }}>
                                                {editorTranslations['WebSMS.TransEditor.PropertyKey']}
                                            </div>
                                            <div style={{ flex: '0 0 24px', height: '20px' }}>
                                                {sortDirection && sortBy === 'value' ?
                                                    <FAIcon name={sortDirection === 'asc' ? 'arrow-up fa-light' : 'arrow-down  fa-light'} prefix={"fas"} style={{ color: '#999' }} />
                                                    : null}
                                            </div>
                                        </div>
                                    </th>
                                    <th key="modules" onClick={_ => this.onSort('module')} style={{ position: 'sticky', zIndex: 9999, top: '0', minWidth: '85px', cursor: 'pointer', borderLeft: '1px solid rgb(215, 215, 215)', borderRight: '1px solid rgb(215, 215, 215)', boxShadow: '0 2px 2px - 1px rgba(0, 0, 0, 0.4)' }}>
                                        <div style={{ minHeight: '36px', maxHeight: '36px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '5px 0 0 18px', borderTop: '1px solid rgb(215, 215, 215)', borderBottom: '1px solid rgb(205, 205, 205)', background: 'rgb(245, 245, 245)', textAlign: 'left', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                            <div style={{ flex: '1 1 auto', paddingLeft: '3px' }}>
                                                {editorTranslations['WebSMS.ReportMetadata.App']}
                                            </div>
                                            <div style={{ flex: '0 0 24px', height: '20px' }}>
                                                {sortDirection && sortBy === 'module' ?
                                                    <FAIcon name={sortDirection === 'asc' ? 'arrow-up fa-light' : 'arrow-down  fa-light'} prefix={"fas"} style={{ color: '#999' }} />
                                                    : null}
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {propertyKeys?.map((key, index) => {
                                    return (
                                        <tr key={key.key}>
                                            <td key={key.key + '.value'} style={{ borderLeft: '1px solid rgb(225, 225, 225)' }} onMouseEnter={_ => this.setState({ tableRowHovered: key.key })} onMouseLeave={_ => this.setState({ tableRowHovered: null })}>
                                                <div title={key.key} style={{ minWidth: columnWidth, maxWidth: columnWidth, height: '36px', padding: '5px 6px 0 10px', background: tableRowHovered == key.key ? 'rgb(229 229 229)' : (index % 2 === 1 ? 'rgb(245, 245, 245)' : 'white'), textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                                    {key.key}
                                                </div>
                                            </td>
                                            <td key={key.key + '.module'} style={{ borderLeft: '1px solid rgb(225, 225, 225)', borderRight: '1px solid rgb(225, 225, 225)' }} onMouseEnter={_ => this.setState({ tableRowHovered: key.key })} onMouseLeave={_ => this.setState({ tableRowHovered: null })}>
                                                <div title={key.module} style={{ minWidth: columnWidth, maxWidth: columnWidth, height: '36px', padding: '5px 6px 0 10px', background: tableRowHovered == key.key ? 'rgb(229 229 229)' : (index % 2 === 1 ? 'rgb(245, 245, 245)' : 'white'), textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                                    {key.module}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </Dialog>
            </div>
        );
    }
}

class TranslationMultiSelect extends React.Component<TranslationMultiSelectProps, TranslationMultiSelectState> {

    constructor(props) {
        super(props);

        this.state = {
            update: false,
            hoveredId: null
        };
    }

    componentDidUpdate() {
        if (this.state.update) {
            this.setState({
                update: false
            });
        }
    }

    onSelect = (event) => {
        const { id } = event.target;
        const { multiSelect, onChange } = this.props;
        const { selectedIds } = multiSelect;

        if (!this.state.update && includes(selectedIds, id)) {
            onChange('selectedId', id);
        }
    }

    onClear = () => {           
        this.props.onChange('selectedIds', []);
    }

    removeId = (event) => {
        const { id } = event.target;
        const { multiSelect, onChange } = this.props;
        const { selectedIds } = multiSelect;

        this.setState({
            update: true
        });

        onChange('selectedIds', selectedIds.filter(i => i !== id));
    }

    selectAll = (event) => {
        this.props.onChange('selectAll', this.props.filteredIds);
    }

    toggleMultiSelect = (enable: boolean) => {
        this.props.onChange('enabled', enable);
    }

    setLabels = (event) => {
        this.props.setLabels(event.target.id);
    }

    render() {
        const { translations, multiSelect, selectedId, editorTranslations } = this.props;


        let selectedTranslations = [];
        let i = 0;
        for (let id of multiSelect.selectedIds) {
            if (find(translations, 'tId', id)) {
                let propertyKey = find(translations, 'tId', id).keys[0].key;
                const backgroundColor = id === selectedId ? 'rgba(23, 61, 120, 0.34)' : (this.state.hoveredId == id ? '#ced3db' : '#e4e7eb');

                selectedTranslations.push(
                    <div key={i} className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base" title={propertyKey} style={{ minWidth: '110px', maxWidth: '110px', height: '30px', padding: '2px 9px', display: 'flex', alignItems: 'center', backgroundColor: backgroundColor }} onMouseEnter={_ => this.setState({ hoveredId: id })} onMouseLeave={_ => this.setState({ hoveredId: null })} >
                        <div id={id} style={{ width: '75px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', textAlign: 'left', paddingTop: '2px' }} onClick={this.onSelect}>
                            {propertyKey}
                        </div>
                        <span id={id} className="k-icon k-font-icon k-i-close-circle" onClick={this.removeId}></span>
                    </div>
                );

                i++;
            }
        }

        const clearButtonProps: ButtonProps = {
            handleClick: this.onClear,
            iconName: "xmark",
            iconStyle: {
                fontWeight: "bold"
            },
            title: editorTranslations['WebSMS.TransEditor.ClearMultiSelect'],
            buttonStyle: {
                marginLeft: "5px",
                borderRadius: "0.375rem",
                borderColor: "rgb(181 188 195)",
                color: "rgb(181 188 195)"
            }
        }

        return (
            <div className="menu-wrapper" style={{ flex: '0 0 ' + (multiSelect.enabled ? '106px' : '58px'), display: 'flex', flexDirection: 'column', justifyContent: 'space-between', paddingTop: '10px', borderBottom: '1px solid rgb(215, 215, 215)' }}>
                {
                    multiSelect.enabled ?
                        <div style={{ display: 'flex', flexFlow: 'row', minHeight: '32px', marginBottom: '16px' }}>
                            <div style={{ flex: '1 1 auto', height: '38px', borderRadius: "0.375rem", border: "1px solid rgb(181 188 195)", margin: '0 5px 0 25px', padding: '3px', overflow: 'hidden' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', gap: '3px', width: '100%', overflowX: 'auto', overflowY: 'hidden', boxSizing: 'content-box', paddingBottom: '25px' }}>
                                    {selectedTranslations}
                                </div>
                            </div>
                            <div style={{ flex: '0 0 62px' }}>
                                <Button {...clearButtonProps} />
                            </div>
                        </div>
                        : null
                }
                <div style={{ minWidth: '100%', maxWidth: '100%', minHeight: '48px', maxHeight: '48px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div style={{ width: '245px', paddingTop: '2px' }}>
                        <SimpleCheckBox name={editorTranslations['WebSMS.TransEditor.MultiSelect']} initialValue={multiSelect.enabled} position={'multiSelect'} onChange={this.toggleMultiSelect} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ margin: '0 10px' }}>
                            <button id="pencil" className="k-button k-grid" type="button" disabled={!multiSelect.enabled} style={{ minWidth: '95px', height: '36px', padding: '0 12px 0 8px', display: 'flex', flexDirection: 'row', borderRadius: '0.375rem' }} onClick={this.selectAll}>
                                <span className="k-icon k-i-plus" style={{ color: 'black' }} />
                                {editorTranslations['WebSMS.TransEditor.SelectAll']}
                            </button>
                        </div>
                        <label className="k-checkbox-label" title={editorTranslations['WebSMS.TransEditor.SetLabels']} style={{ minWidth: '300px', maxWidth: '300px', display: 'block', paddingLeft: '10px', paddingTop: '12px', opacity: multiSelect.enabled ? '1.0' : '0.65', cursor: 'default', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                            {editorTranslations['WebSMS.TransEditor.SetLabels']}
                        </label>
                        <div style={{ marginLeft: '10px' }}>
                            <button id="pencil" className="k-button k-grid" type="button" title={editorTranslations['WebSMS.TransEditor.SetTranslateLabel']} disabled={!multiSelect.enabled} style={{ minWidth: '95px', height: '36px', padding: '0 12px 0 8px', display: 'flex', flexDirection: 'row', borderRadius: '0.375rem' }} onClick={this.setLabels}>
                                <FAIcon name={'pencil'} prefix={"fal"} />
                                translate
                            </button>
                        </div>
                        <div style={{ marginLeft: '10px' }}>
                            <button id="bell" className="k-button k-grid" type="button" title={editorTranslations['WebSMS.TransEditor.SetReviewLabel']} disabled={!multiSelect.enabled} style={{ minWidth: '105px', height: '36px', padding: '0 12px 0 8px', display: 'flex', flexDirection: 'row', borderRadius: '0.375rem' }} onClick={this.setLabels}>
                                <FAIcon name={'bell'} prefix={"fal"} style={{ marginLeft: '1px' }} />
                                review
                            </button>
                        </div>
                        <div style={{ margin: '0 19px 0 10px' }}>
                            <button id="clear" className="k-button k-grid" type="button" title={editorTranslations['WebSMS.TransEditor.RemoveLabels']} disabled={!multiSelect.enabled} style={{ minWidth: '95px', height: '36px', padding: '0 12px', borderRadius: '0.375rem' }} onClick={this.setLabels}>
                                {editorTranslations['WebSMS.TransEditor.ActionClear']}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class SingleDropDownMenu extends React.Component<SingleDropDownMenuProps> {

    constructor(props) {
        super(props);
    }

    onSelect = (field, value, dataItem) => {
        this.props.onSelect(value, this.props.id);
    }

    render() {
        const { name, fieldName, fieldValue, dataSource, initialValue, position, disabled } = this.props;

        let props = {
            field: {
                dataTextField: fieldName,
                dataValueField: fieldValue,
                optionLabel: "",
                type: "drop-down-menu",
                model: "n/a",
                visible: true
            },
            onChange: this.onSelect,
            dataSource: dataSource,
            value: initialValue,
            disabled: disabled
        };

        return (
            <div className="menu-wrapper" style={{ minWidth: '100%', maxWidth: '100%', display: 'flex', flexFlow: 'row', alignItems: 'baseline', marginTop: position && (position === 'paginator' || position === 'drawer') ? '4px' : (position && position === 'details' ? '8px' : '10px'), marginBottom: position && position === 'drawer' ? '5px' : '0', paddingRight: position && (position === 'languageSelection' || position === 'propertyKey') ? '0' : (position && position === 'drawer' ? '15px' : '25px') }}>
                {name && (!position || (position && position !== 'drawer')) ?
                    <label className="text-field-label" title={name} style={{ flex: position && position === 'paginator' ? '1 1 auto' : (position && position === 'filter' ? '0 0 135px' : '0 0 125px'), paddingLeft: '25px', paddingTop: position && position === 'propertyKey' ? '8px' : '10px', paddingRight: '2px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                        {name}
                    </label>
                    : null}
                <div style={{ flex: position && position === 'paginator' ? '0 0 84px' : '1 1 auto', marginLeft: position && position === 'drawer' ? '20px' : (position && position === 'filter' ? '2px' : '4px'), paddingTop: '1px' }}>
                    <DropDownList {...props} />
                </div>
            </div>
        );
    }
}

class MultiDropDownMenu extends React.Component<MultiDropDownMenuProps> {

    constructor(props) {
        super(props);
    }

    onSelect = (field: { model: string }, value) => {
        this.props.onSelect(value);
    }

    render() {
        const { name, fieldName, fieldValue, dataSource, initialValue, position } = this.props;

        let props = {
            field: {
                dataTextField: fieldName,
                dataValueField: fieldValue,
                optionLabel: "",
                type: name + "-menu",
                model: name,
                visible: true,
                primitiveValue: true
            },
            disabled: false,
            onChange: this.onSelect,
            dataSource: dataSource,
            value: initialValue
        };

        return (
            <div className="menu-wrapper" style={{ minWidth: '100%', maxWidth: '100%', display: 'flex', flexFlow: 'row', alignItems: 'baseline', marginBottom: position && position === 'drawer' ? '3px' : '10px', marginTop: this.props.margin ? this.props.margin : '10px', padding: position && position === 'drawer' ? '0 15px 0 18px' : (position && position === 'dialog' ? '0 5px 0 0' : '0 25px 0 0') }}>
                {
                    name ?
                        <label className="text-field-label" title={name} style={{ flex: position && position === 'filter' ? '0 0 135px' : (position && position === 'dialog' ? '0 0 195px' : '0 0 125px'), padding: '10px 3px 0 25px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                            {name}
                        </label>
                        : null
                }
                <div style={{ flex: '1 1 auto', marginLeft: '2px', paddingTop: '1px' }}>
                    <MultiSelect {...props} />
                </div>
            </div>
        );
    }
}

class TranslationValueEditor extends React.Component<TextValueEditorProps, TextValueEditorState> {

    constructor(props) {
        super(props);
        this.state = {
            textValue: '',
            dialogOpen: false
        };
    }

    textBoxValue = '';

    componentDidMount() {
        const { initialValue } = this.props;
        this.setState({
            textValue: initialValue ?? ''
        });
    }

    onChange = (event) => {
        const { value, id } = event.target;
        this.props.onChange(value, id);
    }

    updateTextBox = (value) => {
        this.textBoxValue = value;
        this.setState({});
    }

    clearTextValue = () => {
        this.props.onChange('', this.props.id);
    }

    openDialog = () => {
        this.textBoxValue = this.props.initialValue;
        this.setState({
            dialogOpen: true
        });
    }

    closeDialog = (action) => {
        this.setState({
            dialogOpen: false
        });
        if (action === 'apply') {
            this.props.onChange(this.textBoxValue, this.props.id);
        }
        else {
            this.textBoxValue = this.props.initialValue + '/';
            this.setState({});
        }
    }

    render() {
        const { id, name, initialValue, defaultValue, editorTranslations } = this.props;

        const buttonPropsDialog: ButtonProps = {
            handleClick: this.openDialog,
            id: id + '.ta',
            iconName: "search",
            title: editorTranslations['WebSMS.TransEditor.TextArea'],
            buttonStyle: {
                borderTopLeftRadius: "0.375rem",
                borderBottomLeftRadius: "0.375rem",
                borderTop: "1px solid rgb(181 188 195)",
                borderBottom: "1px solid rgb(181 188 195)",
                borderLeft: "1px solid rgb(181 188 195)",
                borderRight: "none",
                marginLeft: '10px'
            }
        }

        const buttonPropsDelete: ButtonProps = {
            handleClick: this.clearTextValue,
            id: id,
            iconName: "trash-alt",
            title: editorTranslations['WebSMS.TransEditor.ActionDelete'],
            buttonStyle: {
                borderTopRightRadius: "0.375rem",
                borderBottomRightRadius: "0.375rem",
                borderColor: "rgb(181 188 195)"
            }
        }

        const dialogProps: DialogProps = {
            title: editorTranslations['WebSMS.TransEditor.Translation.Header'] + name,
            actions: [
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionCancel'],
                    action: () => this.closeDialog('cancel')
                },
                {
                    label: editorTranslations['WebSMS.TransEditor.ActionApply'],
                    action: () => this.closeDialog('apply'),
                    primary: true
                }],
            afterClose: () => { if (this.state.dialogOpen) this.setState({ dialogOpen: false }) },
            maxHeight: '540px'
        };

        const TextBoxProps: TextBoxProps = {
            field: {
                type: null,
                model: null,
                visible: true,
                triggerOnChange: true,
                multiLine: true
            },
            disabled: false,
            required: false,
            onChange: (_, value: string) => {
                this.updateTextBox(value);
            },
            value: '',
            textAreaHeight: '148px'
        };

        const TextBoxPropsDefault: TextBoxProps = {
            field: {
                type: null,
                model: null,
                visible: true,
                triggerOnChange: true,
                multiLine: true
            },
            disabled: true,
            required: false,
            onChange: (_, value: string) => { },
            value: '',
            textAreaHeight: '148px'
        };

        return (
            <div key={id} className="text-field-wrapper" style={{ minWidth: '100%', maxWidth: '100%', display: 'flex', flexFlow: 'row', marginTop: '10px' }}>
                <div style={{ flex: '1 1 auto', display: 'flex', flexFlow: 'row' }}>
                    <div style={{ flex: '0 0 50%', display: 'flex', flexFlow: 'row', alignItems: 'baseline' }}>
                        <label className="text-field-label" title={name + ' (' + editorTranslations['WebSMS.TransEditor.DefaultTranslation'] + ')'} style={{ flex: '0 0 175px', paddingLeft: '25px', paddingTop: '9px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                            {name + ' (' + editorTranslations['WebSMS.TransEditor.DefaultTranslation'] + ')'}
                        </label>
                        <span className="k-input k-textbox k-input-solid k-input-md k-rounded-md">
                            <input key={id + '.default'} type="text" className="k-input-inner" value={defaultValue ? defaultValue : ''} readOnly={true} style={{ flex: '1 1 auto' }} />
                        </span>
                    </div>
                    <div style={{ flex: '0 0 50%', display: 'flex', flexFlow: 'row', alignItems: 'baseline' }}>
                        <label className="text-field-label" title={name + ' (' + editorTranslations['WebSMS.TransEditor.CustomTranslation'] + ')'} style={{ flex: '0 0 175px', paddingLeft: '25px', paddingTop: '9px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                            {name + ' (' + editorTranslations['WebSMS.TransEditor.CustomTranslation'] + ')'}
                        </label>
                        <span className="k-input k-textbox k-input-solid k-input-md k-rounded-md">
                            <input id={id} key={id} type="text" className="k-input-inner" value={initialValue ? initialValue : ''} onChange={this.onChange} style={{ flex: '1 1 auto' }} />
                        </span>
                    </div>
                </div>
                <div style={{ flex: '0 0 47px' }}>
                    <Button {...buttonPropsDialog} />
                </div>
                <div style={{ flex: '0 0 37px' }}>
                    <Button {...buttonPropsDelete} />
                </div>
                <Dialog {...dialogProps} open={this.state.dialogOpen}>
                    <div style={{ width: '650px', height: '25px', display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                        <h2 style={{ paddingLeft: '6px' }}>{editorTranslations['WebSMS.TransEditor.DefaultTranslation']}</h2>
                    </div>
                    <div style={{ width: '650px', height: '165px', padding: '5px 5px 12px 5px' }}>
                        <TextBox {...TextBoxPropsDefault} value={this.props.defaultValue} />
                    </div>
                    <div style={{ width: '650px', height: '25px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <h2 style={{ paddingLeft: '6px' }}>{editorTranslations['WebSMS.TransEditor.CustomTranslation']}</h2>
                        <div title={editorTranslations['WebSMS.TransEditor.ActionCopy.Title']} style={{ transform: 'scale(110%)', margin: '0 12px 0 0', cursor: 'pointer' }} onClick={_ => this.updateTextBox(this.props.defaultValue)}>
                            <i className="fal fa-copy fa-fw" aria-hidden="true" ></i>
                        </div>
                    </div>
                    <div style={{ width: '650px', height: '165px', padding: '5px 5px 12px 5px' }}>
                        <TextBox {...TextBoxProps} value={this.textBoxValue} />
                    </div>
                </Dialog>
            </div>
        );
    }
}

export class SimpleCheckBox extends React.Component<SingleCheckOptionProps, SingleCheckOptionState> {

    constructor(props) {
        super(props);
        this.state = {
            checkBoxValue: this.props.initialValue
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initialValue !== this.props.initialValue) {
            this.setState((state, props) => {
                return {
                    checkBoxValue: props.initialValue
                };
            });
        }
    }

    onChange = (event) => {
        this.setState((state) => {
            return {
                checkBoxValue: !state.checkBoxValue
            };
        });
        this.props.onChange(event.target.checked);
    }

    render() {
        const { name, position, disabled, title } = this.props;

        return (
            <div style={{ minWidth: '100%', maxWidth: '100%', minHeight: '20px', maxHeight: '20px', display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', margin: position === 'multiSelect' ? '7px 0 11px 5px' : '10px 0 5px 0' }}>
                <input type="checkbox" className="k-checkbox k-checkbox-md k-rounded-md" disabled={disabled ?? false} checked={this.state.checkBoxValue} style={{ minWidth: '20px', marginLeft: '20px' }} onChange={this.onChange} />
                <label className="k-checkbox-label" title={title ?? name} style={{ width: position && position === 'dialog' ? '550px' : '201px', padding: '1px 5px 0 10px', cursor: 'default', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                    {name}
                </label>
            </div>
        );
    }
}

//Hilfsfunktionen

function find(array: any[], prop: string, value: any): any {
    if (!array || array.length === 0) {
        return null;
    }

    for (let v of array) {
        if (v[prop] === value) {
            return v;
        }
    }
    return null;
}

function findIndex(array: any[], prop: string, value: any): number {
    if (!array) {
        return null;
    }

    let i = 0;
    for (let v of array) {
        if (v[prop] === value) {
            return i;
        }
        i++;
    }
    return null;
}

function sort(array: any[], prop: string, direction: 'asc' | 'desc'): any[] {
    if (!array || array.length === 0) {
        return null;
    }

    let sortedArray = [];
    for (let i = 0; i < array.length; i++) {
        let sort;
        for (let e of array) {
            if (!find(sortedArray, prop, e[prop])) {
                if (direction === 'asc' && (!sort || sort[prop] > e[prop])) {
                    sort = e;
                }
                else if (direction === 'desc' && (!sort || sort[prop] < e[prop])) {
                    sort = e;
                }
            }
        }
        sortedArray.push(sort);
    }
    return sortedArray;
}

function includes(array: any[], value: any, prop?: string): boolean {
    if (!array || array.length === 0) {
        return false;
    }
    if (!prop) {
        for (let s of array) {
            if (s === value) {
                return true;
            }
        }
        return false;
    }
    else {
        for (let e of array) {
            if (e[prop] === value[prop]) {
                return true;
            }
        }
        return false;
    }
}

function arraysEqual(array1: any[], array2: any[], prop?: string): boolean {
    if (!array1 || !array2 || array1.length !== array2.length) {
        return false;
    }
    else {
        for (let e of array1) {
            if ((!prop && !includes(array2, e)) || !find(array2, prop, e[prop])) {
                return false;
            }
        }
    }
    return true;
}

function notInArray(array1: any[], array2: any[], prop: string): any[] {
    let notContained = [];
    if (!array2 || array2.length === 0) {
        return notContained;
    }

    for (let e of array2) {
        if (!includes(array1, e, prop)) {
            notContained.push(e);
        }
    }
    return notContained;
}

//translation data model
export interface Translations {
    translations: Translation[];
}

export interface Translation {
    tId: string;
    translationKey: string;
    keys: TranslationPropertyKey[];
    translationsPerLanguage: Record<string, TranslationPerLanguage | null>;
    moduleIds: string[];
}

export interface TranslationPropertyKey {
    moduleId: string;
    key: string;
}

export interface TranslationPerLanguage {
    tId: string;
    langId: string;
    langCode: string;
    value: TranslationValue;
    label: Label;
}

export interface TranslationValue {
    default: string;
    defaultId: string;
    custom: string | null;
    customId: string | null;
}

export interface Language {
    langId: string;
    langCode: string;
    displayName: string;
    displayNameNative?: string;
}

export interface Module {
    moduleId: string;
    moduleName: string;
    displayName: string;
}

export interface Label {
    labelId: string;
    name: string;
    iconName: string;
}

export interface Revision {
    moduleId: string;
    revisionsPerLanguage: Record<string, RevisionPerLanguage>;
}

export interface RevisionPerLanguage {
    langCode: string;
    revisionTranslations: any[];
    updateDate?: string;
    userName?: string;
}

//component interfaces
export interface EditorProps {
    editorTranslations: Record<string, string>;
}

export interface NewPropertyKeyDialogProps extends EditorProps {
    open: boolean;
    closeDialog: Function;
    existingKeys: string[];
    modules: Module[];
    init: boolean;
    onInit: Function;
}

export interface TranslationRevisionDialogProps extends EditorProps {
    doInit: boolean;
    onInit: Function;
    saveDialogOpen: boolean;
    globalModules: Module[];
    currentRevisions: Revision[];
    translations: Translation[];
    globalLanguages: Language[];
    translationFilter: Filter;
    closeDialog: Function;
}

export interface TranslationNotificationProps extends EditorProps {
    type: 'translations' | 'revisions' | 'saveError';
    modules: Module[];
    content?: string | string[] | number;
    errorKeys?: string[];
    timestamp: string;
    close: Function;
}

export interface TranslationSearchFilterProps extends EditorProps {
    globalLanguages: Language[];
    globalModules: Module[];
    labels: Label[];
    currentFilter: Filter;
    onChange: Function;
}

export interface LanguageSelectionProps extends EditorProps {
    globalLanguages: Language[];
    initialValue: string[];
    onChange: Function;
}

export interface TranslationSettingsProps extends EditorProps {
    settings: Settings;
    onChange: Function;
}

export interface TranslationImportExportProps extends EditorProps {
    translations: Translation[];
    selectedLanguages: string[];
    globalLanguages: Language[];
    selectedIds: string[];
    multiSelect: boolean;
    replaceTranslations: Function;
}

export interface TranslationImportDialogProps extends EditorProps {
    importDialogOpen: boolean;
    importedTranslations: any[];
    translations: Translation[];
    globalLanguages: Language[];
    closeDialog: Function;
}

export interface TranslationDevImportExportProps extends EditorProps {
    translations: Translation[];
    globalLanguages: Language[];
    selectedIds: string[];
    multiSelect: boolean;
    replaceTranslations: Function;
}

export interface TranslationTableProps extends EditorProps {
    tableWidth: number;
    translations: Translations;
    translationFilter: Filter;
    globalLanguages: Language[];
    selectedRow: number;
    selectedId: string;
    pageNumber: number;
    itemsPerPage: number;
    propertyKeysExtendedIds: string[];
    selectPage: Function;
    selectRow: Function;
    multiSelect: MultiSelection;
    changeTranslation: Function;
    onSelect: Function;
    setIds: Function;
    onExtend: Function;
    onSort: Function;
}

export interface ComponentProps {
    name: string;
    initialValue: any;
    onChange: Function;
}

export interface TextValueEditorProps extends ComponentProps, EditorProps {
    initialValue: string;
    defaultValue: string;
    id: string;
}

export interface SingleCheckOptionProps extends ComponentProps {
    initialValue: boolean;
    disabled?: boolean;
    position?: string;
    title?: string;
}

export interface SearchBarProps extends EditorProps {
    name: string;
    onSubmit: Function;
}

export interface DataTableProps extends EditorProps {
    tableWidth: number;
    languages: string[];
    dataSource: any[];
    globalLanguages: Language[];
    selectedRow: number;
    selectedId: string;
    multiSelect: MultiSelection;
    searchValue: string;
    propertyKeysExtendedIds: string[];
    selectRow: Function;
    onSelect: Function;
    onExtend: Function;
    onSort: Function;
}

export interface SortHeaderProps extends EditorProps {
    languages: string[];
    globalLanguages: Language[];
    onSort: Function;
}

export interface Sort {
    column: string;
    direction: 'asc' | 'desc' | null;
}

export interface PaginatorProps extends EditorProps {
    itemCount: number;
    itemsPerPage: number;
    pageNumber: number;
    onChange: Function;
}

export interface Filter {
    selectedModules: Module[];
    selectedLabel: Label;
    selectedLanguages: string[];
    searchValue: string;
}

export interface Settings {
    setReviewed: boolean;
    autoRemove: boolean;
}

export interface TranslationDetailsProps extends EditorProps {
    translation: Translation;
    languages: string[];
    globalLanguages: Language[];
    globalModules: Module[];
    labels: Label[];
    onChange: Function;
}

export interface TranslationMultiSelectProps extends EditorProps {
    translations: Translation[];
    multiSelect: MultiSelection;
    selectedId: string;
    filteredIds: string[];
    onChange: Function;
    setLabels: Function;
}

export interface SingleDropDownMenuProps {
    id: string;
    name: string;
    dataSource: any[];
    fieldName: any;
    fieldValue: any;
    initialValue: any;
    onSelect: Function;
    disabled?: boolean;
    position?: string;
}

export interface MultiDropDownMenuProps {
    name: string;
    dataSource: any[];
    fieldName: any;
    fieldValue: any;
    initialValue?: any[];
    margin?: string;
    onSelect: Function;
    position?: string;
}

export interface TranslationEditorViewState {
    translations: Translations;
    customResourcesAvailable: boolean;
    globalLanguages: Language[];
    globalModules: Module[];
    filterLabels: any[];
    translationFilter: Filter;
    translationSettings: Settings;
    multiSelect: MultiSelection;
    selectedRow: number;
    selectedId: string;
    pageNumber: number;
    itemsPerPage: number;
    saveDialogOpen: boolean;
    saveDialogInit: boolean;
    currentRevisions: Revision[];
    propertyKeysExtendedIds: string[];
    buttonHoverEnabled: boolean;
    propertyKeyDialogOpen: boolean;
    propertyKeyDialogInit: boolean;
    importResourceDialogOpen: boolean;
}

export interface NewPropertyKeyDialogState {
    propertyKey: string;
    moduleId: string;
}

export interface TranslationRevisionDialogState {
    moduleIds: string[];
    forLabels: string[];
    selectedLanguages: string[];
    filteredTranslationsPerModule: any[];
    shownModule: string;
}

export interface TranslationImportExportState {
    format: 'xlsx' | 'csv' | 'json';
    selectedOnly: boolean;
    selectedLanguages: string[];
    importDialogOpen: boolean;
    confirmationDialogOpen: boolean;
}

export interface TranslationImportDialogState {
    selectedLanguages: string[];
}

export interface TranslationDevImportExportState {
    selectedOnly: boolean;
    importDialogOpen: boolean;
    importFile: any;
}

export interface DataTableState {
    hovered: number | null;
}

export interface TranslationMultiSelectState {
    update: boolean;
    hoveredId: string | null;
}

export interface MultiSelection {
    enabled: boolean;
    selectedIds: string[];
}

export interface TranslationDetailsState {
    infoDialogOpen: boolean;
    tableRowHovered: string | null;
    sortDirection: 'asc' | 'desc' | null;
    sortBy: 'value' | 'module' | null;
}

export interface TextValueEditorState {
    textValue: string;
    dialogOpen: boolean;
}

export interface SortHeaderState {
    sortDirection: 'asc' | 'desc' | null;
    sortColumn: string;
}

export interface SingleCheckOptionState {
    checkBoxValue: boolean;
}